var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTtten(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1422 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    stroke: "hsl(290, 87%, 47%)",
    fill: "none",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 20,
    y2: 20,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 0,
    x2: 40,
    y2: 20,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 0,
    x2: 40,
    y2: 20,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 0,
    x2: 60,
    y2: 20,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 0,
    x2: 100,
    y2: 20,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 0,
    x2: 120,
    y2: 20,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 0,
    x2: 120,
    y2: 20,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 0,
    x2: 140,
    y2: 20,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 0,
    x2: 160,
    y2: 20,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 0,
    x2: 180,
    y2: 20,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 0,
    x2: 200,
    y2: 20,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 0,
    x2: 240,
    y2: 20,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 0,
    x2: 260,
    y2: 20,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 0,
    x2: 260,
    y2: 20,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 0,
    x2: 300,
    y2: 20,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 0,
    x2: 300,
    y2: 20,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 0,
    x2: 320,
    y2: 20,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 0,
    x2: 340,
    y2: 20,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 0,
    x2: 380,
    y2: 20,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 0,
    x2: 400,
    y2: 20,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 0,
    x2: 420,
    y2: 20,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 0,
    x2: 420,
    y2: 20,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 0,
    x2: 440,
    y2: 20,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 0,
    x2: 480,
    y2: 20,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 0,
    x2: 500,
    y2: 20,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 0,
    x2: 520,
    y2: 20,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 0,
    x2: 520,
    y2: 20,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 0,
    x2: 560,
    y2: 20,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 0,
    x2: 580,
    y2: 20,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 0,
    x2: 600,
    y2: 20,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 0,
    x2: 620,
    y2: 20,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 0,
    x2: 640,
    y2: 20,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 0,
    x2: 660,
    y2: 20,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 0,
    x2: 660,
    y2: 20,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 0,
    x2: 680,
    y2: 20,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 0,
    x2: 720,
    y2: 20,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 0,
    x2: 740,
    y2: 20,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 0,
    x2: 740,
    y2: 20,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 0,
    x2: 780,
    y2: 20,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 0,
    x2: 800,
    y2: 20,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 0,
    x2: 800,
    y2: 20,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 0,
    x2: 840,
    y2: 20,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 0,
    x2: 860,
    y2: 20,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 0,
    x2: 880,
    y2: 20,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 0,
    x2: 880,
    y2: 20,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 0,
    x2: 900,
    y2: 20,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 0,
    x2: 920,
    y2: 20,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 0,
    x2: 960,
    y2: 20,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 0,
    x2: 960,
    y2: 20,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 0,
    x2: 1000,
    y2: 20,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 0,
    x2: 1000,
    y2: 20,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 0,
    x2: 1020,
    y2: 20,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 0,
    x2: 1060,
    y2: 20,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 0,
    x2: 1080,
    y2: 20,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 0,
    x2: 1080,
    y2: 20,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 0,
    x2: 1120,
    y2: 20,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 0,
    x2: 1120,
    y2: 20,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 0,
    x2: 1160,
    y2: 20,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 0,
    x2: 1180,
    y2: 20,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 0,
    x2: 1200,
    y2: 20,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 0,
    x2: 1220,
    y2: 20,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 0,
    x2: 1220,
    y2: 20,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 0,
    x2: 1260,
    y2: 20,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 0,
    x2: 1260,
    y2: 20,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 0,
    x2: 1300,
    y2: 20,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 0,
    x2: 1320,
    y2: 20,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 0,
    x2: 1340,
    y2: 20,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 0,
    x2: 1340,
    y2: 20,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 0,
    x2: 1380,
    y2: 20,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 0,
    x2: 1380,
    y2: 20,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 0,
    x2: 1400,
    y2: 20,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 0,
    x2: 1420,
    y2: 20,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 20,
    x2: 20,
    y2: 40,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 40,
    y2: 40,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 20,
    x2: 60,
    y2: 40,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 20,
    x2: 80,
    y2: 40,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 20,
    x2: 100,
    y2: 40,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 20,
    x2: 100,
    y2: 40,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 20,
    x2: 120,
    y2: 40,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 20,
    x2: 160,
    y2: 40,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 20,
    x2: 180,
    y2: 40,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 20,
    x2: 180,
    y2: 40,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 20,
    x2: 200,
    y2: 40,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 20,
    x2: 240,
    y2: 40,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 20,
    x2: 240,
    y2: 40,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 20,
    x2: 260,
    y2: 40,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 20,
    x2: 300,
    y2: 40,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 20,
    x2: 300,
    y2: 40,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 20,
    x2: 320,
    y2: 40,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 20,
    x2: 360,
    y2: 40,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 20,
    x2: 360,
    y2: 40,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 20,
    x2: 400,
    y2: 40,
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 20,
    x2: 420,
    y2: 40,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 20,
    x2: 420,
    y2: 40,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 20,
    x2: 460,
    y2: 40,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 20,
    x2: 460,
    y2: 40,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 20,
    x2: 480,
    y2: 40,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 20,
    x2: 520,
    y2: 40,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 20,
    x2: 540,
    y2: 40,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 20,
    x2: 560,
    y2: 40,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 20,
    x2: 580,
    y2: 40,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 20,
    x2: 580,
    y2: 40,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 20,
    x2: 600,
    y2: 40,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 20,
    x2: 620,
    y2: 40,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 20,
    x2: 660,
    y2: 40,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 20,
    x2: 660,
    y2: 40,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 20,
    x2: 680,
    y2: 40,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 20,
    x2: 700,
    y2: 40,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 20,
    x2: 740,
    y2: 40,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 20,
    x2: 760,
    y2: 40,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 20,
    x2: 760,
    y2: 40,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 20,
    x2: 800,
    y2: 40,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 20,
    x2: 820,
    y2: 40,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 20,
    x2: 820,
    y2: 40,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 20,
    x2: 840,
    y2: 40,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 20,
    x2: 880,
    y2: 40,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 20,
    x2: 900,
    y2: 40,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 20,
    x2: 900,
    y2: 40,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 20,
    x2: 920,
    y2: 40,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 20,
    x2: 960,
    y2: 40,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 20,
    x2: 980,
    y2: 40,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 20,
    x2: 1000,
    y2: 40,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 20,
    x2: 1020,
    y2: 40,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 20,
    x2: 1020,
    y2: 40,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 20,
    x2: 1060,
    y2: 40,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 20,
    x2: 1060,
    y2: 40,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 20,
    x2: 1100,
    y2: 40,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 20,
    x2: 1100,
    y2: 40,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 20,
    x2: 1120,
    y2: 40,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 20,
    x2: 1140,
    y2: 40,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 20,
    x2: 1180,
    y2: 40,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 20,
    x2: 1200,
    y2: 40,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 20,
    x2: 1200,
    y2: 40,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 20,
    x2: 1220,
    y2: 40,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 20,
    x2: 1260,
    y2: 40,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 20,
    x2: 1260,
    y2: 40,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 20,
    x2: 1280,
    y2: 40,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 20,
    x2: 1300,
    y2: 40,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 20,
    x2: 1320,
    y2: 40,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 20,
    x2: 1360,
    y2: 40,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 20,
    x2: 1380,
    y2: 40,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 20,
    x2: 1400,
    y2: 40,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 20,
    x2: 1420,
    y2: 40,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 20,
    x2: 1440,
    y2: 40,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 40,
    x2: 20,
    y2: 60,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 40,
    x2: 20,
    y2: 60,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 40,
    x2: 40,
    y2: 60,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 40,
    x2: 60,
    y2: 60,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 40,
    x2: 80,
    y2: 60,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 40,
    x2: 100,
    y2: 60,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 40,
    x2: 140,
    y2: 60,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 40,
    x2: 160,
    y2: 60,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 40,
    x2: 180,
    y2: 60,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 40,
    x2: 200,
    y2: 60,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 40,
    x2: 220,
    y2: 60,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 40,
    x2: 240,
    y2: 60,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 40,
    x2: 240,
    y2: 60,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 40,
    x2: 260,
    y2: 60,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 40,
    x2: 300,
    y2: 60,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 40,
    x2: 300,
    y2: 60,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 40,
    x2: 320,
    y2: 60,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 40,
    x2: 340,
    y2: 60,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 40,
    x2: 360,
    y2: 60,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 40,
    x2: 400,
    y2: 60,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 40,
    x2: 400,
    y2: 60,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 40,
    x2: 440,
    y2: 60,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 40,
    x2: 460,
    y2: 60,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 40,
    x2: 480,
    y2: 60,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 40,
    x2: 500,
    y2: 60,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 40,
    x2: 500,
    y2: 60,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 40,
    x2: 540,
    y2: 60,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 40,
    x2: 560,
    y2: 60,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 40,
    x2: 580,
    y2: 60,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 40,
    x2: 580,
    y2: 60,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 40,
    x2: 600,
    y2: 60,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 40,
    x2: 640,
    y2: 60,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 40,
    x2: 660,
    y2: 60,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 40,
    x2: 680,
    y2: 60,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 40,
    x2: 700,
    y2: 60,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 40,
    x2: 720,
    y2: 60,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 40,
    x2: 720,
    y2: 60,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 40,
    x2: 740,
    y2: 60,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 40,
    x2: 760,
    y2: 60,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 40,
    x2: 780,
    y2: 60,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 40,
    x2: 800,
    y2: 60,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 40,
    x2: 820,
    y2: 60,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 40,
    x2: 840,
    y2: 60,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 40,
    x2: 860,
    y2: 60,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 40,
    x2: 900,
    y2: 60,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 40,
    x2: 900,
    y2: 60,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 40,
    x2: 920,
    y2: 60,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 40,
    x2: 940,
    y2: 60,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 40,
    x2: 980,
    y2: 60,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 40,
    x2: 980,
    y2: 60,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 40,
    x2: 1020,
    y2: 60,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 40,
    x2: 1020,
    y2: 60,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 40,
    x2: 1040,
    y2: 60,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 40,
    x2: 1060,
    y2: 60,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 40,
    x2: 1080,
    y2: 60,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 40,
    x2: 1120,
    y2: 60,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 40,
    x2: 1140,
    y2: 60,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 40,
    x2: 1140,
    y2: 60,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 40,
    x2: 1160,
    y2: 60,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 40,
    x2: 1180,
    y2: 60,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 40,
    x2: 1200,
    y2: 60,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 40,
    x2: 1220,
    y2: 60,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 40,
    x2: 1240,
    y2: 60,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 40,
    x2: 1280,
    y2: 60,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 40,
    x2: 1280,
    y2: 60,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 40,
    x2: 1300,
    y2: 60,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 40,
    x2: 1340,
    y2: 60,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 40,
    x2: 1360,
    y2: 60,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 40,
    x2: 1380,
    y2: 60,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 40,
    x2: 1380,
    y2: 60,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 40,
    x2: 1420,
    y2: 60,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 40,
    x2: 1420,
    y2: 60,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 60,
    x2: 20,
    y2: 80,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 60,
    x2: 40,
    y2: 80,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 60,
    x2: 60,
    y2: 80,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 60,
    x2: 60,
    y2: 80,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 60,
    x2: 80,
    y2: 80,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 60,
    x2: 120,
    y2: 80,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 60,
    x2: 120,
    y2: 80,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 60,
    x2: 140,
    y2: 80,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 60,
    x2: 180,
    y2: 80,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 60,
    x2: 200,
    y2: 80,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 60,
    x2: 200,
    y2: 80,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 60,
    x2: 240,
    y2: 80,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 60,
    x2: 240,
    y2: 80,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 60,
    x2: 280,
    y2: 80,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 60,
    x2: 280,
    y2: 80,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 60,
    x2: 320,
    y2: 80,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 60,
    x2: 320,
    y2: 80,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 60,
    x2: 340,
    y2: 80,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 60,
    x2: 360,
    y2: 80,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 60,
    x2: 380,
    y2: 80,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 60,
    x2: 400,
    y2: 80,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 60,
    x2: 420,
    y2: 80,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 60,
    x2: 440,
    y2: 80,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 60,
    x2: 480,
    y2: 80,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 60,
    x2: 480,
    y2: 80,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 60,
    x2: 520,
    y2: 80,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 60,
    x2: 520,
    y2: 80,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 60,
    x2: 540,
    y2: 80,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 60,
    x2: 580,
    y2: 80,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 60,
    x2: 580,
    y2: 80,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 60,
    x2: 600,
    y2: 80,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 60,
    x2: 640,
    y2: 80,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 60,
    x2: 640,
    y2: 80,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 60,
    x2: 680,
    y2: 80,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 60,
    x2: 700,
    y2: 80,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 60,
    x2: 700,
    y2: 80,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 60,
    x2: 720,
    y2: 80,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 60,
    x2: 760,
    y2: 80,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 60,
    x2: 760,
    y2: 80,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 60,
    x2: 780,
    y2: 80,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 60,
    x2: 800,
    y2: 80,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 60,
    x2: 820,
    y2: 80,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 60,
    x2: 840,
    y2: 80,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 60,
    x2: 880,
    y2: 80,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 60,
    x2: 880,
    y2: 80,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 60,
    x2: 920,
    y2: 80,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 60,
    x2: 920,
    y2: 80,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 60,
    x2: 940,
    y2: 80,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 60,
    x2: 980,
    y2: 80,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 60,
    x2: 1000,
    y2: 80,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 60,
    x2: 1020,
    y2: 80,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 60,
    x2: 1020,
    y2: 80,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 60,
    x2: 1040,
    y2: 80,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 60,
    x2: 1060,
    y2: 80,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 60,
    x2: 1100,
    y2: 80,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 60,
    x2: 1120,
    y2: 80,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 60,
    x2: 1140,
    y2: 80,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 60,
    x2: 1140,
    y2: 80,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 60,
    x2: 1160,
    y2: 80,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 60,
    x2: 1200,
    y2: 80,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 60,
    x2: 1200,
    y2: 80,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 60,
    x2: 1240,
    y2: 80,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 60,
    x2: 1260,
    y2: 80,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 60,
    x2: 1260,
    y2: 80,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 60,
    x2: 1280,
    y2: 80,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 60,
    x2: 1320,
    y2: 80,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 60,
    x2: 1320,
    y2: 80,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 60,
    x2: 1340,
    y2: 80,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 60,
    x2: 1360,
    y2: 80,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 60,
    x2: 1380,
    y2: 80,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 60,
    x2: 1400,
    y2: 80,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 60,
    x2: 1440,
    y2: 80,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 80,
    x2: 20,
    y2: 100,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 80,
    x2: 20,
    y2: 100,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 80,
    x2: 40,
    y2: 100,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 80,
    x2: 80,
    y2: 100,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 80,
    x2: 80,
    y2: 100,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 80,
    x2: 120,
    y2: 100,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 80,
    x2: 120,
    y2: 100,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 80,
    x2: 160,
    y2: 100,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 80,
    x2: 160,
    y2: 100,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 80,
    x2: 200,
    y2: 100,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 80,
    x2: 200,
    y2: 100,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 80,
    x2: 240,
    y2: 100,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 80,
    x2: 260,
    y2: 100,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 80,
    x2: 280,
    y2: 100,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 80,
    x2: 300,
    y2: 100,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 80,
    x2: 300,
    y2: 100,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 80,
    x2: 340,
    y2: 100,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 80,
    x2: 340,
    y2: 100,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 80,
    x2: 360,
    y2: 100,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 80,
    x2: 380,
    y2: 100,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 80,
    x2: 400,
    y2: 100,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 80,
    x2: 420,
    y2: 100,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 80,
    x2: 460,
    y2: 100,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 80,
    x2: 460,
    y2: 100,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 80,
    x2: 480,
    y2: 100,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 80,
    x2: 520,
    y2: 100,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 80,
    x2: 520,
    y2: 100,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 80,
    x2: 540,
    y2: 100,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 80,
    x2: 580,
    y2: 100,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 80,
    x2: 600,
    y2: 100,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 80,
    x2: 600,
    y2: 100,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 80,
    x2: 620,
    y2: 100,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 80,
    x2: 660,
    y2: 100,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 80,
    x2: 660,
    y2: 100,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 80,
    x2: 680,
    y2: 100,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 80,
    x2: 720,
    y2: 100,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 80,
    x2: 740,
    y2: 100,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 80,
    x2: 740,
    y2: 100,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 80,
    x2: 760,
    y2: 100,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 80,
    x2: 780,
    y2: 100,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 80,
    x2: 800,
    y2: 100,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 80,
    x2: 820,
    y2: 100,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 80,
    x2: 860,
    y2: 100,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 80,
    x2: 880,
    y2: 100,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 80,
    x2: 880,
    y2: 100,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 80,
    x2: 900,
    y2: 100,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 80,
    x2: 940,
    y2: 100,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 80,
    x2: 940,
    y2: 100,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 80,
    x2: 980,
    y2: 100,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 80,
    x2: 1000,
    y2: 100,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 80,
    x2: 1020,
    y2: 100,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 80,
    x2: 1040,
    y2: 100,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 80,
    x2: 1060,
    y2: 100,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 80,
    x2: 1080,
    y2: 100,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 80,
    x2: 1080,
    y2: 100,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 80,
    x2: 1120,
    y2: 100,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 80,
    x2: 1140,
    y2: 100,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 80,
    x2: 1160,
    y2: 100,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 80,
    x2: 1160,
    y2: 100,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 80,
    x2: 1200,
    y2: 100,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 80,
    x2: 1200,
    y2: 100,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 80,
    x2: 1240,
    y2: 100,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 80,
    x2: 1260,
    y2: 100,
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 80,
    x2: 1260,
    y2: 100,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 80,
    x2: 1300,
    y2: 100,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 80,
    x2: 1300,
    y2: 100,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 80,
    x2: 1340,
    y2: 100,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 80,
    x2: 1340,
    y2: 100,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 80,
    x2: 1380,
    y2: 100,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 80,
    x2: 1400,
    y2: 100,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 80,
    x2: 1400,
    y2: 100,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 80,
    x2: 1440,
    y2: 100,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 100,
    x2: 20,
    y2: 120,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 100,
    x2: 20,
    y2: 120,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 100,
    x2: 40,
    y2: 120,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 100,
    x2: 60,
    y2: 120,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 100,
    x2: 80,
    y2: 120,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 100,
    x2: 120,
    y2: 120,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 100,
    x2: 140,
    y2: 120,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 100,
    x2: 160,
    y2: 120,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 100,
    x2: 160,
    y2: 120,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 100,
    x2: 200,
    y2: 120,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 100,
    x2: 220,
    y2: 120,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 100,
    x2: 220,
    y2: 120,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 100,
    x2: 240,
    y2: 120,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 100,
    x2: 260,
    y2: 120,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 100,
    x2: 280,
    y2: 120,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 100,
    x2: 320,
    y2: 120,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 100,
    x2: 320,
    y2: 120,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 100,
    x2: 360,
    y2: 120,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 100,
    x2: 360,
    y2: 120,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 100,
    x2: 400,
    y2: 120,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 100,
    x2: 420,
    y2: 120,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 100,
    x2: 420,
    y2: 120,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 100,
    x2: 440,
    y2: 120,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 100,
    x2: 480,
    y2: 120,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 100,
    x2: 500,
    y2: 120,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 100,
    x2: 520,
    y2: 120,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 100,
    x2: 540,
    y2: 120,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 100,
    x2: 540,
    y2: 120,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 100,
    x2: 560,
    y2: 120,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 100,
    x2: 580,
    y2: 120,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 100,
    x2: 620,
    y2: 120,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 100,
    x2: 640,
    y2: 120,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 100,
    x2: 640,
    y2: 120,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 100,
    x2: 680,
    y2: 120,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 100,
    x2: 680,
    y2: 120,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 100,
    x2: 720,
    y2: 120,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 100,
    x2: 720,
    y2: 120,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 100,
    x2: 740,
    y2: 120,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 100,
    x2: 760,
    y2: 120,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 100,
    x2: 780,
    y2: 120,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 100,
    x2: 820,
    y2: 120,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 100,
    x2: 840,
    y2: 120,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 100,
    x2: 860,
    y2: 120,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 100,
    x2: 880,
    y2: 120,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 100,
    x2: 900,
    y2: 120,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 100,
    x2: 920,
    y2: 120,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 100,
    x2: 920,
    y2: 120,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 100,
    x2: 940,
    y2: 120,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 100,
    x2: 960,
    y2: 120,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 100,
    x2: 980,
    y2: 120,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 100,
    x2: 1000,
    y2: 120,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 100,
    x2: 1020,
    y2: 120,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 100,
    x2: 1060,
    y2: 120,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 100,
    x2: 1080,
    y2: 120,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 100,
    x2: 1080,
    y2: 120,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 100,
    x2: 1100,
    y2: 120,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 100,
    x2: 1140,
    y2: 120,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 100,
    x2: 1140,
    y2: 120,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 100,
    x2: 1180,
    y2: 120,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 100,
    x2: 1200,
    y2: 120,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 100,
    x2: 1200,
    y2: 120,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 100,
    x2: 1220,
    y2: 120,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 100,
    x2: 1240,
    y2: 120,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 100,
    x2: 1280,
    y2: 120,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 100,
    x2: 1280,
    y2: 120,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 100,
    x2: 1300,
    y2: 120,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 100,
    x2: 1340,
    y2: 120,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 100,
    x2: 1340,
    y2: 120,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 100,
    x2: 1360,
    y2: 120,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 100,
    x2: 1400,
    y2: 120,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 100,
    x2: 1420,
    y2: 120,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 100,
    x2: 1420,
    y2: 120,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 120,
    x2: 20,
    y2: 140,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 120,
    x2: 20,
    y2: 140,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 120,
    x2: 40,
    y2: 140,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 120,
    x2: 60,
    y2: 140,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 120,
    x2: 100,
    y2: 140,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 120,
    x2: 100,
    y2: 140,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 120,
    x2: 120,
    y2: 140,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 120,
    x2: 140,
    y2: 140,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 120,
    x2: 160,
    y2: 140,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 120,
    x2: 200,
    y2: 140,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 120,
    x2: 200,
    y2: 140,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 120,
    x2: 240,
    y2: 140,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 120,
    x2: 240,
    y2: 140,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 120,
    x2: 280,
    y2: 140,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 120,
    x2: 300,
    y2: 140,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 120,
    x2: 320,
    y2: 140,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 120,
    x2: 340,
    y2: 140,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 120,
    x2: 340,
    y2: 140,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 120,
    x2: 360,
    y2: 140,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 120,
    x2: 400,
    y2: 140,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 120,
    x2: 400,
    y2: 140,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 120,
    x2: 420,
    y2: 140,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 120,
    x2: 440,
    y2: 140,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 120,
    x2: 460,
    y2: 140,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 120,
    x2: 480,
    y2: 140,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 120,
    x2: 500,
    y2: 140,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 120,
    x2: 540,
    y2: 140,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 120,
    x2: 560,
    y2: 140,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 120,
    x2: 580,
    y2: 140,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 120,
    x2: 580,
    y2: 140,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 120,
    x2: 600,
    y2: 140,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 120,
    x2: 620,
    y2: 140,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 120,
    x2: 640,
    y2: 140,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 120,
    x2: 680,
    y2: 140,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 120,
    x2: 680,
    y2: 140,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 120,
    x2: 700,
    y2: 140,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 120,
    x2: 720,
    y2: 140,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 120,
    x2: 740,
    y2: 140,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 120,
    x2: 780,
    y2: 140,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 120,
    x2: 780,
    y2: 140,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 120,
    x2: 820,
    y2: 140,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 120,
    x2: 840,
    y2: 140,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 120,
    x2: 860,
    y2: 140,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 120,
    x2: 880,
    y2: 140,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 120,
    x2: 900,
    y2: 140,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 120,
    x2: 920,
    y2: 140,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 120,
    x2: 940,
    y2: 140,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 120,
    x2: 960,
    y2: 140,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 120,
    x2: 960,
    y2: 140,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 120,
    x2: 980,
    y2: 140,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 120,
    x2: 1020,
    y2: 140,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 120,
    x2: 1040,
    y2: 140,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 120,
    x2: 1040,
    y2: 140,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 120,
    x2: 1080,
    y2: 140,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 120,
    x2: 1080,
    y2: 140,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 120,
    x2: 1120,
    y2: 140,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 120,
    x2: 1120,
    y2: 140,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 120,
    x2: 1140,
    y2: 140,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 120,
    x2: 1160,
    y2: 140,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 120,
    x2: 1180,
    y2: 140,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 120,
    x2: 1220,
    y2: 140,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 120,
    x2: 1240,
    y2: 140,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 120,
    x2: 1240,
    y2: 140,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 120,
    x2: 1280,
    y2: 140,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 120,
    x2: 1280,
    y2: 140,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 120,
    x2: 1320,
    y2: 140,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 120,
    x2: 1320,
    y2: 140,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 120,
    x2: 1340,
    y2: 140,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 120,
    x2: 1380,
    y2: 140,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 120,
    x2: 1380,
    y2: 140,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 120,
    x2: 1400,
    y2: 140,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 120,
    x2: 1440,
    y2: 140,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 140,
    x2: 20,
    y2: 160,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 140,
    x2: 20,
    y2: 160,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 140,
    x2: 40,
    y2: 160,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 140,
    x2: 80,
    y2: 160,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 140,
    x2: 100,
    y2: 160,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 140,
    x2: 120,
    y2: 160,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 140,
    x2: 120,
    y2: 160,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 140,
    x2: 140,
    y2: 160,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 140,
    x2: 160,
    y2: 160,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 140,
    x2: 180,
    y2: 160,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 140,
    x2: 200,
    y2: 160,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 140,
    x2: 220,
    y2: 160,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 140,
    x2: 260,
    y2: 160,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 140,
    x2: 280,
    y2: 160,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 140,
    x2: 280,
    y2: 160,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 140,
    x2: 300,
    y2: 160,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 140,
    x2: 320,
    y2: 160,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 140,
    x2: 340,
    y2: 160,
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 140,
    x2: 360,
    y2: 160,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 140,
    x2: 400,
    y2: 160,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 140,
    x2: 400,
    y2: 160,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 140,
    x2: 440,
    y2: 160,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 140,
    x2: 460,
    y2: 160,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 140,
    x2: 460,
    y2: 160,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 140,
    x2: 500,
    y2: 160,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 140,
    x2: 500,
    y2: 160,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 140,
    x2: 520,
    y2: 160,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 140,
    x2: 540,
    y2: 160,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 140,
    x2: 580,
    y2: 160,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 140,
    x2: 600,
    y2: 160,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 140,
    x2: 600,
    y2: 160,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 140,
    x2: 640,
    y2: 160,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 140,
    x2: 640,
    y2: 160,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 140,
    x2: 680,
    y2: 160,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 140,
    x2: 700,
    y2: 160,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 140,
    x2: 700,
    y2: 160,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 140,
    x2: 720,
    y2: 160,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 140,
    x2: 760,
    y2: 160,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 140,
    x2: 760,
    y2: 160,
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 140,
    x2: 780,
    y2: 160,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 140,
    x2: 800,
    y2: 160,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 140,
    x2: 820,
    y2: 160,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 140,
    x2: 840,
    y2: 160,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 140,
    x2: 880,
    y2: 160,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 140,
    x2: 880,
    y2: 160,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 140,
    x2: 920,
    y2: 160,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 140,
    x2: 920,
    y2: 160,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 140,
    x2: 940,
    y2: 160,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 140,
    x2: 980,
    y2: 160,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 140,
    x2: 1000,
    y2: 160,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 140,
    x2: 1020,
    y2: 160,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 140,
    x2: 1020,
    y2: 160,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 140,
    x2: 1060,
    y2: 160,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 140,
    x2: 1060,
    y2: 160,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 140,
    x2: 1080,
    y2: 160,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 140,
    x2: 1120,
    y2: 160,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 140,
    x2: 1120,
    y2: 160,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 140,
    x2: 1160,
    y2: 160,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 140,
    x2: 1160,
    y2: 160,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 140,
    x2: 1180,
    y2: 160,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 140,
    x2: 1200,
    y2: 160,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 140,
    x2: 1240,
    y2: 160,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 140,
    x2: 1240,
    y2: 160,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 140,
    x2: 1280,
    y2: 160,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 140,
    x2: 1280,
    y2: 160,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 140,
    x2: 1320,
    y2: 160,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 140,
    x2: 1340,
    y2: 160,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 140,
    x2: 1340,
    y2: 160,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 140,
    x2: 1360,
    y2: 160,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 140,
    x2: 1400,
    y2: 160,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 140,
    x2: 1420,
    y2: 160,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 140,
    x2: 1420,
    y2: 160,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 160,
    x2: 0,
    y2: 180,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 160,
    x2: 20,
    y2: 180,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 160,
    x2: 40,
    y2: 180,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 160,
    x2: 60,
    y2: 180,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 160,
    x2: 100,
    y2: 180,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 160,
    x2: 100,
    y2: 180,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 160,
    x2: 140,
    y2: 180,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 160,
    x2: 140,
    y2: 180,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 160,
    x2: 180,
    y2: 180,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 160,
    x2: 180,
    y2: 180,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 160,
    x2: 220,
    y2: 180,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 160,
    x2: 220,
    y2: 180,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 160,
    x2: 240,
    y2: 180,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 160,
    x2: 260,
    y2: 180,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 160,
    x2: 280,
    y2: 180,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 160,
    x2: 320,
    y2: 180,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 160,
    x2: 320,
    y2: 180,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 160,
    x2: 360,
    y2: 180,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 160,
    x2: 380,
    y2: 180,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 160,
    x2: 380,
    y2: 180,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 160,
    x2: 420,
    y2: 180,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 160,
    x2: 440,
    y2: 180,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 160,
    x2: 460,
    y2: 180,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 160,
    x2: 460,
    y2: 180,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 160,
    x2: 480,
    y2: 180,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 160,
    x2: 520,
    y2: 180,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 160,
    x2: 540,
    y2: 180,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 160,
    x2: 540,
    y2: 180,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 160,
    x2: 560,
    y2: 180,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 160,
    x2: 580,
    y2: 180,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 160,
    x2: 600,
    y2: 180,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 160,
    x2: 640,
    y2: 180,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 160,
    x2: 660,
    y2: 180,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 160,
    x2: 660,
    y2: 180,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 160,
    x2: 700,
    y2: 180,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 160,
    x2: 700,
    y2: 180,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 160,
    x2: 740,
    y2: 180,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 160,
    x2: 760,
    y2: 180,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 160,
    x2: 780,
    y2: 180,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 160,
    x2: 780,
    y2: 180,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 160,
    x2: 800,
    y2: 180,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 160,
    x2: 840,
    y2: 180,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 160,
    x2: 840,
    y2: 180,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 160,
    x2: 880,
    y2: 180,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 160,
    x2: 900,
    y2: 180,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 160,
    x2: 900,
    y2: 180,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 160,
    x2: 940,
    y2: 180,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 160,
    x2: 960,
    y2: 180,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 160,
    x2: 980,
    y2: 180,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 160,
    x2: 980,
    y2: 180,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 160,
    x2: 1020,
    y2: 180,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 160,
    x2: 1040,
    y2: 180,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 160,
    x2: 1040,
    y2: 180,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 160,
    x2: 1060,
    y2: 180,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 160,
    x2: 1080,
    y2: 180,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 160,
    x2: 1120,
    y2: 180,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 160,
    x2: 1140,
    y2: 180,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 160,
    x2: 1160,
    y2: 180,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 160,
    x2: 1160,
    y2: 180,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 160,
    x2: 1200,
    y2: 180,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 160,
    x2: 1200,
    y2: 180,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 160,
    x2: 1220,
    y2: 180,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 160,
    x2: 1240,
    y2: 180,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 160,
    x2: 1280,
    y2: 180,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 160,
    x2: 1300,
    y2: 180,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 160,
    x2: 1320,
    y2: 180,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 160,
    x2: 1340,
    y2: 180,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 160,
    x2: 1340,
    y2: 180,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 160,
    x2: 1380,
    y2: 180,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 160,
    x2: 1400,
    y2: 180,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 160,
    x2: 1400,
    y2: 180,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 160,
    x2: 1440,
    y2: 180,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 180,
    x2: 20,
    y2: 200,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 180,
    x2: 40,
    y2: 200,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 180,
    x2: 60,
    y2: 200,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 180,
    x2: 60,
    y2: 200,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 180,
    x2: 80,
    y2: 200,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 180,
    x2: 120,
    y2: 200,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 180,
    x2: 120,
    y2: 200,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 180,
    x2: 140,
    y2: 200,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 180,
    x2: 180,
    y2: 200,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 180,
    x2: 200,
    y2: 200,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 180,
    x2: 200,
    y2: 200,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 180,
    x2: 220,
    y2: 200,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 180,
    x2: 260,
    y2: 200,
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 180,
    x2: 260,
    y2: 200,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 180,
    x2: 280,
    y2: 200,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 180,
    x2: 300,
    y2: 200,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 180,
    x2: 340,
    y2: 200,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 180,
    x2: 360,
    y2: 200,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 180,
    x2: 380,
    y2: 200,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 180,
    x2: 400,
    y2: 200,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 180,
    x2: 400,
    y2: 200,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 180,
    x2: 440,
    y2: 200,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 180,
    x2: 440,
    y2: 200,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 180,
    x2: 460,
    y2: 200,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 180,
    x2: 480,
    y2: 200,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 180,
    x2: 500,
    y2: 200,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 180,
    x2: 520,
    y2: 200,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 180,
    x2: 560,
    y2: 200,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 180,
    x2: 560,
    y2: 200,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 180,
    x2: 580,
    y2: 200,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 180,
    x2: 620,
    y2: 200,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 180,
    x2: 640,
    y2: 200,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 180,
    x2: 640,
    y2: 200,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 180,
    x2: 660,
    y2: 200,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 180,
    x2: 700,
    y2: 200,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 180,
    x2: 700,
    y2: 200,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 180,
    x2: 740,
    y2: 200,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 180,
    x2: 740,
    y2: 200,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 180,
    x2: 760,
    y2: 200,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 180,
    x2: 800,
    y2: 200,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 180,
    x2: 820,
    y2: 200,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 180,
    x2: 840,
    y2: 200,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 180,
    x2: 840,
    y2: 200,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 180,
    x2: 860,
    y2: 200,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 180,
    x2: 900,
    y2: 200,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 180,
    x2: 920,
    y2: 200,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 180,
    x2: 920,
    y2: 200,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 180,
    x2: 960,
    y2: 200,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 180,
    x2: 980,
    y2: 200,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 180,
    x2: 980,
    y2: 200,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 180,
    x2: 1000,
    y2: 200,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 180,
    x2: 1040,
    y2: 200,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 180,
    x2: 1060,
    y2: 200,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 180,
    x2: 1060,
    y2: 200,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 180,
    x2: 1080,
    y2: 200,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 180,
    x2: 1120,
    y2: 200,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 180,
    x2: 1120,
    y2: 200,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 180,
    x2: 1160,
    y2: 200,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 180,
    x2: 1180,
    y2: 200,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 180,
    x2: 1180,
    y2: 200,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 180,
    x2: 1200,
    y2: 200,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 180,
    x2: 1240,
    y2: 200,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 180,
    x2: 1240,
    y2: 200,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 180,
    x2: 1280,
    y2: 200,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 180,
    x2: 1300,
    y2: 200,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 180,
    x2: 1300,
    y2: 200,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 180,
    x2: 1320,
    y2: 200,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 180,
    x2: 1340,
    y2: 200,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 180,
    x2: 1360,
    y2: 200,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 180,
    x2: 1380,
    y2: 200,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 180,
    x2: 1420,
    y2: 200,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 180,
    x2: 1440,
    y2: 200,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 200,
    x2: 20,
    y2: 220,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 200,
    x2: 40,
    y2: 220,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 200,
    x2: 60,
    y2: 220,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 200,
    x2: 80,
    y2: 220,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 200,
    x2: 100,
    y2: 220,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 200,
    x2: 120,
    y2: 220,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 200,
    x2: 120,
    y2: 220,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 200,
    x2: 160,
    y2: 220,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 200,
    x2: 160,
    y2: 220,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 200,
    x2: 180,
    y2: 220,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 200,
    x2: 220,
    y2: 220,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 200,
    x2: 220,
    y2: 220,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 200,
    x2: 240,
    y2: 220,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 200,
    x2: 280,
    y2: 220,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 200,
    x2: 280,
    y2: 220,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 200,
    x2: 300,
    y2: 220,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 200,
    x2: 340,
    y2: 220,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 200,
    x2: 340,
    y2: 220,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 200,
    x2: 380,
    y2: 220,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 200,
    x2: 400,
    y2: 220,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 200,
    x2: 420,
    y2: 220,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 200,
    x2: 440,
    y2: 220,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 200,
    x2: 440,
    y2: 220,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 200,
    x2: 460,
    y2: 220,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 200,
    x2: 500,
    y2: 220,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 200,
    x2: 520,
    y2: 220,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 200,
    x2: 540,
    y2: 220,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 200,
    x2: 540,
    y2: 220,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 200,
    x2: 560,
    y2: 220,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 200,
    x2: 600,
    y2: 220,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 200,
    x2: 600,
    y2: 220,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 200,
    x2: 640,
    y2: 220,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 200,
    x2: 660,
    y2: 220,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 200,
    x2: 680,
    y2: 220,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 200,
    x2: 680,
    y2: 220,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 200,
    x2: 720,
    y2: 220,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 200,
    x2: 740,
    y2: 220,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 200,
    x2: 740,
    y2: 220,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 200,
    x2: 780,
    y2: 220,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 200,
    x2: 780,
    y2: 220,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 200,
    x2: 800,
    y2: 220,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 200,
    x2: 820,
    y2: 220,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 200,
    x2: 860,
    y2: 220,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 200,
    x2: 860,
    y2: 220,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 200,
    x2: 880,
    y2: 220,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 200,
    x2: 920,
    y2: 220,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 200,
    x2: 920,
    y2: 220,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 200,
    x2: 960,
    y2: 220,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 200,
    x2: 980,
    y2: 220,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 200,
    x2: 980,
    y2: 220,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 200,
    x2: 1020,
    y2: 220,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 200,
    x2: 1040,
    y2: 220,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 200,
    x2: 1040,
    y2: 220,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 200,
    x2: 1080,
    y2: 220,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 200,
    x2: 1080,
    y2: 220,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 200,
    x2: 1120,
    y2: 220,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 200,
    x2: 1120,
    y2: 220,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 200,
    x2: 1160,
    y2: 220,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 200,
    x2: 1180,
    y2: 220,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 200,
    x2: 1180,
    y2: 220,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 200,
    x2: 1220,
    y2: 220,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 200,
    x2: 1240,
    y2: 220,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 200,
    x2: 1240,
    y2: 220,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 200,
    x2: 1260,
    y2: 220,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 200,
    x2: 1280,
    y2: 220,
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 200,
    x2: 1320,
    y2: 220,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 200,
    x2: 1320,
    y2: 220,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 200,
    x2: 1360,
    y2: 220,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 200,
    x2: 1380,
    y2: 220,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 200,
    x2: 1380,
    y2: 220,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 200,
    x2: 1400,
    y2: 220,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 200,
    x2: 1420,
    y2: 220,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 220,
    x2: 0,
    y2: 240,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 220,
    x2: 20,
    y2: 240,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 220,
    x2: 40,
    y2: 240,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 220,
    x2: 80,
    y2: 240,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 220,
    x2: 80,
    y2: 240,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 220,
    x2: 120,
    y2: 240,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 220,
    x2: 140,
    y2: 240,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 220,
    x2: 140,
    y2: 240,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 220,
    x2: 180,
    y2: 240,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 220,
    x2: 200,
    y2: 240,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 220,
    x2: 200,
    y2: 240,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 220,
    x2: 220,
    y2: 240,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 220,
    x2: 260,
    y2: 240,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 220,
    x2: 280,
    y2: 240,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 220,
    x2: 300,
    y2: 240,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 220,
    x2: 300,
    y2: 240,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 220,
    x2: 340,
    y2: 240,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 220,
    x2: 360,
    y2: 240,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 220,
    x2: 380,
    y2: 240,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 220,
    x2: 380,
    y2: 240,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 220,
    x2: 400,
    y2: 240,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 220,
    x2: 440,
    y2: 240,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 220,
    x2: 440,
    y2: 240,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 220,
    x2: 460,
    y2: 240,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 220,
    x2: 480,
    y2: 240,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 220,
    x2: 520,
    y2: 240,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 220,
    x2: 540,
    y2: 240,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 220,
    x2: 540,
    y2: 240,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 220,
    x2: 560,
    y2: 240,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 220,
    x2: 600,
    y2: 240,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 220,
    x2: 620,
    y2: 240,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 220,
    x2: 620,
    y2: 240,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 220,
    x2: 660,
    y2: 240,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 220,
    x2: 680,
    y2: 240,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 220,
    x2: 700,
    y2: 240,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 220,
    x2: 700,
    y2: 240,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 220,
    x2: 720,
    y2: 240,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 220,
    x2: 740,
    y2: 240,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 220,
    x2: 760,
    y2: 240,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 220,
    x2: 780,
    y2: 240,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 220,
    x2: 820,
    y2: 240,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 220,
    x2: 820,
    y2: 240,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 220,
    x2: 860,
    y2: 240,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 220,
    x2: 880,
    y2: 240,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 220,
    x2: 880,
    y2: 240,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 220,
    x2: 900,
    y2: 240,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 220,
    x2: 920,
    y2: 240,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 220,
    x2: 940,
    y2: 240,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 220,
    x2: 960,
    y2: 240,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 220,
    x2: 980,
    y2: 240,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 220,
    x2: 1000,
    y2: 240,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 220,
    x2: 1040,
    y2: 240,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 220,
    x2: 1060,
    y2: 240,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 220,
    x2: 1060,
    y2: 240,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 220,
    x2: 1100,
    y2: 240,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 220,
    x2: 1100,
    y2: 240,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 220,
    x2: 1120,
    y2: 240,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 220,
    x2: 1140,
    y2: 240,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 220,
    x2: 1180,
    y2: 240,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 220,
    x2: 1200,
    y2: 240,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 220,
    x2: 1220,
    y2: 240,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 220,
    x2: 1240,
    y2: 240,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 220,
    x2: 1240,
    y2: 240,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 220,
    x2: 1280,
    y2: 240,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 220,
    x2: 1300,
    y2: 240,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 220,
    x2: 1300,
    y2: 240,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 220,
    x2: 1320,
    y2: 240,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 220,
    x2: 1340,
    y2: 240,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 220,
    x2: 1380,
    y2: 240,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 220,
    x2: 1380,
    y2: 240,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 220,
    x2: 1400,
    y2: 240,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 220,
    x2: 1440,
    y2: 240,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 240,
    x2: 20,
    y2: 260,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 240,
    x2: 20,
    y2: 260,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 240,
    x2: 40,
    y2: 260,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 240,
    x2: 60,
    y2: 260,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 240,
    x2: 80,
    y2: 260,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 240,
    x2: 100,
    y2: 260,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 240,
    x2: 120,
    y2: 260,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 240,
    x2: 160,
    y2: 260,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 240,
    x2: 180,
    y2: 260,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 240,
    x2: 200,
    y2: 260,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 240,
    x2: 220,
    y2: 260,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 240,
    x2: 240,
    y2: 260,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 240,
    x2: 260,
    y2: 260,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 240,
    x2: 280,
    y2: 260,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 240,
    x2: 280,
    y2: 260,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 240,
    x2: 300,
    y2: 260,
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 240,
    x2: 340,
    y2: 260,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 240,
    x2: 360,
    y2: 260,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 240,
    x2: 380,
    y2: 260,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 240,
    x2: 380,
    y2: 260,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 240,
    x2: 400,
    y2: 260,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 240,
    x2: 420,
    y2: 260,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 240,
    x2: 440,
    y2: 260,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 240,
    x2: 480,
    y2: 260,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 240,
    x2: 500,
    y2: 260,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 240,
    x2: 500,
    y2: 260,
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 240,
    x2: 540,
    y2: 260,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 240,
    x2: 560,
    y2: 260,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 240,
    x2: 580,
    y2: 260,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 240,
    x2: 580,
    y2: 260,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 240,
    x2: 620,
    y2: 260,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 240,
    x2: 640,
    y2: 260,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 240,
    x2: 640,
    y2: 260,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 240,
    x2: 680,
    y2: 260,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 240,
    x2: 680,
    y2: 260,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 240,
    x2: 700,
    y2: 260,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 240,
    x2: 720,
    y2: 260,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 240,
    x2: 740,
    y2: 260,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 240,
    x2: 760,
    y2: 260,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 240,
    x2: 780,
    y2: 260,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 240,
    x2: 820,
    y2: 260,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 240,
    x2: 840,
    y2: 260,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 240,
    x2: 860,
    y2: 260,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 240,
    x2: 860,
    y2: 260,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 240,
    x2: 880,
    y2: 260,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 240,
    x2: 900,
    y2: 260,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 240,
    x2: 920,
    y2: 260,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 240,
    x2: 940,
    y2: 260,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 240,
    x2: 960,
    y2: 260,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 240,
    x2: 1000,
    y2: 260,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 240,
    x2: 1000,
    y2: 260,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 240,
    x2: 1040,
    y2: 260,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 240,
    x2: 1060,
    y2: 260,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 240,
    x2: 1080,
    y2: 260,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 240,
    x2: 1100,
    y2: 260,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 240,
    x2: 1120,
    y2: 260,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 240,
    x2: 1140,
    y2: 260,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 240,
    x2: 1140,
    y2: 260,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 240,
    x2: 1160,
    y2: 260,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 240,
    x2: 1180,
    y2: 260,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 240,
    x2: 1220,
    y2: 260,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 240,
    x2: 1220,
    y2: 260,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 240,
    x2: 1240,
    y2: 260,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 240,
    x2: 1280,
    y2: 260,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 240,
    x2: 1280,
    y2: 260,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 240,
    x2: 1320,
    y2: 260,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 240,
    x2: 1340,
    y2: 260,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 240,
    x2: 1360,
    y2: 260,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 240,
    x2: 1360,
    y2: 260,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 240,
    x2: 1380,
    y2: 260,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 240,
    x2: 1420,
    y2: 260,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 240,
    x2: 1440,
    y2: 260,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 260,
    x2: 20,
    y2: 280,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 260,
    x2: 20,
    y2: 280,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 260,
    x2: 40,
    y2: 280,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 260,
    x2: 80,
    y2: 280,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 260,
    x2: 100,
    y2: 280,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 260,
    x2: 100,
    y2: 280,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 260,
    x2: 120,
    y2: 280,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 260,
    x2: 140,
    y2: 280,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 260,
    x2: 160,
    y2: 280,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 260,
    x2: 180,
    y2: 280,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 260,
    x2: 220,
    y2: 280,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 260,
    x2: 240,
    y2: 280,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 260,
    x2: 240,
    y2: 280,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 260,
    x2: 260,
    y2: 280,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 260,
    x2: 300,
    y2: 280,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 260,
    x2: 300,
    y2: 280,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 260,
    x2: 320,
    y2: 280,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 260,
    x2: 360,
    y2: 280,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 260,
    x2: 360,
    y2: 280,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 260,
    x2: 380,
    y2: 280,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 260,
    x2: 400,
    y2: 280,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 260,
    x2: 420,
    y2: 280,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 260,
    x2: 460,
    y2: 280,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 260,
    x2: 460,
    y2: 280,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 260,
    x2: 500,
    y2: 280,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 260,
    x2: 500,
    y2: 280,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 260,
    x2: 520,
    y2: 280,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 260,
    x2: 560,
    y2: 280,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 260,
    x2: 580,
    y2: 280,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 260,
    x2: 600,
    y2: 280,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 260,
    x2: 620,
    y2: 280,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 260,
    x2: 640,
    y2: 280,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 260,
    x2: 640,
    y2: 280,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 260,
    x2: 680,
    y2: 280,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 260,
    x2: 700,
    y2: 280,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 260,
    x2: 700,
    y2: 280,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 260,
    x2: 720,
    y2: 280,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 260,
    x2: 760,
    y2: 280,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 260,
    x2: 780,
    y2: 280,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 260,
    x2: 800,
    y2: 280,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 260,
    x2: 800,
    y2: 280,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 260,
    x2: 820,
    y2: 280,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 260,
    x2: 840,
    y2: 280,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 260,
    x2: 880,
    y2: 280,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 260,
    x2: 900,
    y2: 280,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 260,
    x2: 900,
    y2: 280,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 260,
    x2: 940,
    y2: 280,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 260,
    x2: 960,
    y2: 280,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 260,
    x2: 980,
    y2: 280,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 260,
    x2: 980,
    y2: 280,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 260,
    x2: 1020,
    y2: 280,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 260,
    x2: 1020,
    y2: 280,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 260,
    x2: 1060,
    y2: 280,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 260,
    x2: 1060,
    y2: 280,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 260,
    x2: 1100,
    y2: 280,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 260,
    x2: 1120,
    y2: 280,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 260,
    x2: 1120,
    y2: 280,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 260,
    x2: 1140,
    y2: 280,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 260,
    x2: 1160,
    y2: 280,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 260,
    x2: 1200,
    y2: 280,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 260,
    x2: 1220,
    y2: 280,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 260,
    x2: 1220,
    y2: 280,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 260,
    x2: 1260,
    y2: 280,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 260,
    x2: 1260,
    y2: 280,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 260,
    x2: 1280,
    y2: 280,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 260,
    x2: 1300,
    y2: 280,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 260,
    x2: 1340,
    y2: 280,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 260,
    x2: 1360,
    y2: 280,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 260,
    x2: 1360,
    y2: 280,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 260,
    x2: 1400,
    y2: 280,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 260,
    x2: 1400,
    y2: 280,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 260,
    x2: 1420,
    y2: 280,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 280,
    x2: 20,
    y2: 300,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 280,
    x2: 40,
    y2: 300,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 280,
    x2: 40,
    y2: 300,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 280,
    x2: 60,
    y2: 300,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 280,
    x2: 80,
    y2: 300,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 280,
    x2: 120,
    y2: 300,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 280,
    x2: 140,
    y2: 300,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 280,
    x2: 160,
    y2: 300,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 280,
    x2: 160,
    y2: 300,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 280,
    x2: 180,
    y2: 300,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 280,
    x2: 220,
    y2: 300,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 280,
    x2: 220,
    y2: 300,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 280,
    x2: 260,
    y2: 300,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 280,
    x2: 280,
    y2: 300,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 280,
    x2: 300,
    y2: 300,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 280,
    x2: 320,
    y2: 300,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 280,
    x2: 340,
    y2: 300,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 280,
    x2: 340,
    y2: 300,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 280,
    x2: 360,
    y2: 300,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 280,
    x2: 400,
    y2: 300,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 280,
    x2: 400,
    y2: 300,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 280,
    x2: 440,
    y2: 300,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 280,
    x2: 440,
    y2: 300,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 280,
    x2: 480,
    y2: 300,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 280,
    x2: 480,
    y2: 300,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 280,
    x2: 520,
    y2: 300,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 280,
    x2: 540,
    y2: 300,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 280,
    x2: 560,
    y2: 300,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 280,
    x2: 580,
    y2: 300,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 280,
    x2: 580,
    y2: 300,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 280,
    x2: 620,
    y2: 300,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 280,
    x2: 640,
    y2: 300,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 280,
    x2: 660,
    y2: 300,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 280,
    x2: 660,
    y2: 300,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 280,
    x2: 700,
    y2: 300,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 280,
    x2: 700,
    y2: 300,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 280,
    x2: 720,
    y2: 300,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 280,
    x2: 760,
    y2: 300,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 280,
    x2: 780,
    y2: 300,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 280,
    x2: 780,
    y2: 300,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 280,
    x2: 800,
    y2: 300,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 280,
    x2: 840,
    y2: 300,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 280,
    x2: 860,
    y2: 300,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 280,
    x2: 860,
    y2: 300,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 280,
    x2: 900,
    y2: 300,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 280,
    x2: 900,
    y2: 300,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 280,
    x2: 940,
    y2: 300,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 280,
    x2: 940,
    y2: 300,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 280,
    x2: 960,
    y2: 300,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 280,
    x2: 1000,
    y2: 300,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 280,
    x2: 1020,
    y2: 300,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 280,
    x2: 1020,
    y2: 300,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 280,
    x2: 1040,
    y2: 300,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 280,
    x2: 1080,
    y2: 300,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 280,
    x2: 1100,
    y2: 300,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 280,
    x2: 1120,
    y2: 300,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 280,
    x2: 1120,
    y2: 300,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 280,
    x2: 1140,
    y2: 300,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 280,
    x2: 1160,
    y2: 300,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 280,
    x2: 1200,
    y2: 300,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 280,
    x2: 1220,
    y2: 300,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 280,
    x2: 1220,
    y2: 300,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 280,
    x2: 1260,
    y2: 300,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 280,
    x2: 1280,
    y2: 300,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 280,
    x2: 1280,
    y2: 300,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 280,
    x2: 1320,
    y2: 300,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 280,
    x2: 1320,
    y2: 300,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 280,
    x2: 1340,
    y2: 300,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 280,
    x2: 1380,
    y2: 300,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 280,
    x2: 1380,
    y2: 300,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 280,
    x2: 1400,
    y2: 300,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 280,
    x2: 1440,
    y2: 300,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 300,
    x2: 20,
    y2: 320,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 300,
    x2: 20,
    y2: 320,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 300,
    x2: 40,
    y2: 320,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 300,
    x2: 80,
    y2: 320,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 300,
    x2: 80,
    y2: 320,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 300,
    x2: 120,
    y2: 320,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 300,
    x2: 120,
    y2: 320,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 300,
    x2: 160,
    y2: 320,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 300,
    x2: 180,
    y2: 320,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 300,
    x2: 180,
    y2: 320,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 300,
    x2: 200,
    y2: 320,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 300,
    x2: 240,
    y2: 320,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 300,
    x2: 260,
    y2: 320,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 300,
    x2: 260,
    y2: 320,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 300,
    x2: 300,
    y2: 320,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 300,
    x2: 320,
    y2: 320,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 300,
    x2: 340,
    y2: 320,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 300,
    x2: 360,
    y2: 320,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 300,
    x2: 380,
    y2: 320,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 300,
    x2: 400,
    y2: 320,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 300,
    x2: 400,
    y2: 320,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 300,
    x2: 420,
    y2: 320,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 300,
    x2: 440,
    y2: 320,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 300,
    x2: 460,
    y2: 320,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 300,
    x2: 500,
    y2: 320,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 300,
    x2: 500,
    y2: 320,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 300,
    x2: 540,
    y2: 320,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 300,
    x2: 560,
    y2: 320,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 300,
    x2: 560,
    y2: 320,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 300,
    x2: 580,
    y2: 320,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 300,
    x2: 600,
    y2: 320,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 300,
    x2: 640,
    y2: 320,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 300,
    x2: 640,
    y2: 320,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 300,
    x2: 660,
    y2: 320,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 300,
    x2: 700,
    y2: 320,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 300,
    x2: 720,
    y2: 320,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 300,
    x2: 720,
    y2: 320,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 300,
    x2: 740,
    y2: 320,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 300,
    x2: 780,
    y2: 320,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 300,
    x2: 800,
    y2: 320,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 300,
    x2: 800,
    y2: 320,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 300,
    x2: 820,
    y2: 320,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 300,
    x2: 840,
    y2: 320,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 300,
    x2: 860,
    y2: 320,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 300,
    x2: 880,
    y2: 320,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 300,
    x2: 920,
    y2: 320,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 300,
    x2: 920,
    y2: 320,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 300,
    x2: 940,
    y2: 320,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 300,
    x2: 960,
    y2: 320,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 300,
    x2: 980,
    y2: 320,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 300,
    x2: 1020,
    y2: 320,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 300,
    x2: 1040,
    y2: 320,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 300,
    x2: 1060,
    y2: 320,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 300,
    x2: 1060,
    y2: 320,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 300,
    x2: 1080,
    y2: 320,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 300,
    x2: 1120,
    y2: 320,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 300,
    x2: 1140,
    y2: 320,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 300,
    x2: 1140,
    y2: 320,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 300,
    x2: 1160,
    y2: 320,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 300,
    x2: 1200,
    y2: 320,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 300,
    x2: 1200,
    y2: 320,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 300,
    x2: 1220,
    y2: 320,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 300,
    x2: 1260,
    y2: 320,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 300,
    x2: 1260,
    y2: 320,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 300,
    x2: 1280,
    y2: 320,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 300,
    x2: 1300,
    y2: 320,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 300,
    x2: 1340,
    y2: 320,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 300,
    x2: 1360,
    y2: 320,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 300,
    x2: 1360,
    y2: 320,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 300,
    x2: 1380,
    y2: 320,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 300,
    x2: 1400,
    y2: 320,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 300,
    x2: 1420,
    y2: 320,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 320,
    x2: 20,
    y2: 340,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 320,
    x2: 20,
    y2: 340,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 320,
    x2: 60,
    y2: 340,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 320,
    x2: 80,
    y2: 340,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 320,
    x2: 100,
    y2: 340,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 320,
    x2: 120,
    y2: 340,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 320,
    x2: 140,
    y2: 340,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 320,
    x2: 140,
    y2: 340,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 320,
    x2: 160,
    y2: 340,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 320,
    x2: 180,
    y2: 340,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 320,
    x2: 220,
    y2: 340,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 320,
    x2: 220,
    y2: 340,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 320,
    x2: 240,
    y2: 340,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 320,
    x2: 260,
    y2: 340,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 320,
    x2: 300,
    y2: 340,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 320,
    x2: 300,
    y2: 340,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 320,
    x2: 340,
    y2: 340,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 320,
    x2: 360,
    y2: 340,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 320,
    x2: 380,
    y2: 340,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 320,
    x2: 400,
    y2: 340,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 320,
    x2: 400,
    y2: 340,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 320,
    x2: 440,
    y2: 340,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 320,
    x2: 440,
    y2: 340,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 320,
    x2: 480,
    y2: 340,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 320,
    x2: 480,
    y2: 340,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 320,
    x2: 500,
    y2: 340,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 320,
    x2: 540,
    y2: 340,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 320,
    x2: 560,
    y2: 340,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 320,
    x2: 580,
    y2: 340,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 320,
    x2: 600,
    y2: 340,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 320,
    x2: 600,
    y2: 340,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 320,
    x2: 620,
    y2: 340,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 320,
    x2: 660,
    y2: 340,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 320,
    x2: 680,
    y2: 340,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 320,
    x2: 680,
    y2: 340,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 320,
    x2: 700,
    y2: 340,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 320,
    x2: 740,
    y2: 340,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 320,
    x2: 740,
    y2: 340,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 320,
    x2: 760,
    y2: 340,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 320,
    x2: 780,
    y2: 340,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 320,
    x2: 800,
    y2: 340,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 320,
    x2: 820,
    y2: 340,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 320,
    x2: 860,
    y2: 340,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 320,
    x2: 880,
    y2: 340,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 320,
    x2: 900,
    y2: 340,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 320,
    x2: 920,
    y2: 340,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 320,
    x2: 940,
    y2: 340,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 320,
    x2: 960,
    y2: 340,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 320,
    x2: 980,
    y2: 340,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 320,
    x2: 980,
    y2: 340,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 320,
    x2: 1020,
    y2: 340,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 320,
    x2: 1040,
    y2: 340,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 320,
    x2: 1060,
    y2: 340,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 320,
    x2: 1080,
    y2: 340,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 320,
    x2: 1080,
    y2: 340,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 320,
    x2: 1120,
    y2: 340,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 320,
    x2: 1140,
    y2: 340,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 320,
    x2: 1160,
    y2: 340,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 320,
    x2: 1180,
    y2: 340,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 320,
    x2: 1180,
    y2: 340,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 320,
    x2: 1220,
    y2: 340,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 320,
    x2: 1240,
    y2: 340,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 320,
    x2: 1260,
    y2: 340,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 320,
    x2: 1280,
    y2: 340,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 320,
    x2: 1280,
    y2: 340,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 320,
    x2: 1300,
    y2: 340,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 320,
    x2: 1320,
    y2: 340,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 320,
    x2: 1340,
    y2: 340,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 320,
    x2: 1360,
    y2: 340,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 320,
    x2: 1400,
    y2: 340,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 320,
    x2: 1400,
    y2: 340,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 320,
    x2: 1420,
    y2: 340,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 340,
    x2: 20,
    y2: 360,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 340,
    x2: 20,
    y2: 360,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 340,
    x2: 40,
    y2: 360,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 340,
    x2: 80,
    y2: 360,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 340,
    x2: 80,
    y2: 360,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 340,
    x2: 120,
    y2: 360,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 340,
    x2: 120,
    y2: 360,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 340,
    x2: 140,
    y2: 360,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 340,
    x2: 180,
    y2: 360,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 340,
    x2: 200,
    y2: 360,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 340,
    x2: 220,
    y2: 360,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 340,
    x2: 240,
    y2: 360,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 340,
    x2: 260,
    y2: 360,
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 340,
    x2: 260,
    y2: 360,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 340,
    x2: 300,
    y2: 360,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 340,
    x2: 300,
    y2: 360,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 340,
    x2: 340,
    y2: 360,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 340,
    x2: 360,
    y2: 360,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 340,
    x2: 380,
    y2: 360,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 340,
    x2: 400,
    y2: 360,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 340,
    x2: 400,
    y2: 360,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 340,
    x2: 440,
    y2: 360,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 340,
    x2: 440,
    y2: 360,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 340,
    x2: 460,
    y2: 360,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 340,
    x2: 480,
    y2: 360,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 340,
    x2: 500,
    y2: 360,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 340,
    x2: 520,
    y2: 360,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 340,
    x2: 560,
    y2: 360,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 340,
    x2: 580,
    y2: 360,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 340,
    x2: 580,
    y2: 360,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 340,
    x2: 600,
    y2: 360,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 340,
    x2: 620,
    y2: 360,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 340,
    x2: 640,
    y2: 360,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 340,
    x2: 660,
    y2: 360,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 340,
    x2: 680,
    y2: 360,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 340,
    x2: 720,
    y2: 360,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 340,
    x2: 720,
    y2: 360,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 340,
    x2: 760,
    y2: 360,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 340,
    x2: 780,
    y2: 360,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 340,
    x2: 780,
    y2: 360,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 340,
    x2: 820,
    y2: 360,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 340,
    x2: 840,
    y2: 360,
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 340,
    x2: 840,
    y2: 360,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 340,
    x2: 880,
    y2: 360,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 340,
    x2: 900,
    y2: 360,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 340,
    x2: 920,
    y2: 360,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 340,
    x2: 940,
    y2: 360,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 340,
    x2: 940,
    y2: 360,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 340,
    x2: 960,
    y2: 360,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 340,
    x2: 980,
    y2: 360,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 340,
    x2: 1000,
    y2: 360,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 340,
    x2: 1040,
    y2: 360,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 340,
    x2: 1040,
    y2: 360,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 340,
    x2: 1080,
    y2: 360,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 340,
    x2: 1080,
    y2: 360,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 340,
    x2: 1100,
    y2: 360,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 340,
    x2: 1140,
    y2: 360,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 340,
    x2: 1140,
    y2: 360,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 340,
    x2: 1180,
    y2: 360,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 340,
    x2: 1200,
    y2: 360,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 340,
    x2: 1220,
    y2: 360,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 340,
    x2: 1220,
    y2: 360,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 340,
    x2: 1260,
    y2: 360,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 340,
    x2: 1260,
    y2: 360,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 340,
    x2: 1300,
    y2: 360,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 340,
    x2: 1300,
    y2: 360,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 340,
    x2: 1340,
    y2: 360,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 340,
    x2: 1340,
    y2: 360,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 340,
    x2: 1380,
    y2: 360,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 340,
    x2: 1400,
    y2: 360,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 340,
    x2: 1400,
    y2: 360,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 340,
    x2: 1440,
    y2: 360,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 360,
    x2: 20,
    y2: 380,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 360,
    x2: 40,
    y2: 380,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 360,
    x2: 60,
    y2: 380,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 360,
    x2: 60,
    y2: 380,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 360,
    x2: 80,
    y2: 380,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 360,
    x2: 100,
    y2: 380,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 360,
    x2: 140,
    y2: 380,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 360,
    x2: 140,
    y2: 380,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 360,
    x2: 180,
    y2: 380,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 360,
    x2: 180,
    y2: 380,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 360,
    x2: 220,
    y2: 380,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 360,
    x2: 220,
    y2: 380,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 360,
    x2: 260,
    y2: 380,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 360,
    x2: 260,
    y2: 380,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 360,
    x2: 280,
    y2: 380,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 360,
    x2: 320,
    y2: 380,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 360,
    x2: 320,
    y2: 380,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 360,
    x2: 360,
    y2: 380,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 360,
    x2: 360,
    y2: 380,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 360,
    x2: 400,
    y2: 380,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 360,
    x2: 420,
    y2: 380,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 360,
    x2: 440,
    y2: 380,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 360,
    x2: 440,
    y2: 380,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 360,
    x2: 460,
    y2: 380,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 360,
    x2: 500,
    y2: 380,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 360,
    x2: 500,
    y2: 380,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 360,
    x2: 540,
    y2: 380,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 360,
    x2: 560,
    y2: 380,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 360,
    x2: 580,
    y2: 380,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 360,
    x2: 600,
    y2: 380,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 360,
    x2: 600,
    y2: 380,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 360,
    x2: 640,
    y2: 380,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 360,
    x2: 660,
    y2: 380,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 360,
    x2: 680,
    y2: 380,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 360,
    x2: 700,
    y2: 380,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 360,
    x2: 720,
    y2: 380,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 360,
    x2: 720,
    y2: 380,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 360,
    x2: 740,
    y2: 380,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 360,
    x2: 760,
    y2: 380,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 360,
    x2: 780,
    y2: 380,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 360,
    x2: 820,
    y2: 380,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 360,
    x2: 840,
    y2: 380,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 360,
    x2: 840,
    y2: 380,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 360,
    x2: 880,
    y2: 380,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 360,
    x2: 900,
    y2: 380,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 360,
    x2: 900,
    y2: 380,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 360,
    x2: 940,
    y2: 380,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 360,
    x2: 960,
    y2: 380,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 360,
    x2: 960,
    y2: 380,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 360,
    x2: 1000,
    y2: 380,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 360,
    x2: 1020,
    y2: 380,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 360,
    x2: 1040,
    y2: 380,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 360,
    x2: 1040,
    y2: 380,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 360,
    x2: 1080,
    y2: 380,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 360,
    x2: 1100,
    y2: 380,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 360,
    x2: 1100,
    y2: 380,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 360,
    x2: 1140,
    y2: 380,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 360,
    x2: 1140,
    y2: 380,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 360,
    x2: 1180,
    y2: 380,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 360,
    x2: 1180,
    y2: 380,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 360,
    x2: 1220,
    y2: 380,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 360,
    x2: 1220,
    y2: 380,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 360,
    x2: 1260,
    y2: 380,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 360,
    x2: 1280,
    y2: 380,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 360,
    x2: 1300,
    y2: 380,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 360,
    x2: 1320,
    y2: 380,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 360,
    x2: 1320,
    y2: 380,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 360,
    x2: 1340,
    y2: 380,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 360,
    x2: 1380,
    y2: 380,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 360,
    x2: 1380,
    y2: 380,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 360,
    x2: 1400,
    y2: 380,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 360,
    x2: 1420,
    y2: 380,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 380,
    x2: 20,
    y2: 400,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 380,
    x2: 40,
    y2: 400,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 380,
    x2: 40,
    y2: 400,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 380,
    x2: 80,
    y2: 400,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 380,
    x2: 80,
    y2: 400,
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 380,
    x2: 100,
    y2: 400,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 380,
    x2: 140,
    y2: 400,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 380,
    x2: 160,
    y2: 400,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 380,
    x2: 160,
    y2: 400,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 380,
    x2: 200,
    y2: 400,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 380,
    x2: 220,
    y2: 400,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 380,
    x2: 240,
    y2: 400,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 380,
    x2: 240,
    y2: 400,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 380,
    x2: 280,
    y2: 400,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 380,
    x2: 280,
    y2: 400,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 380,
    x2: 320,
    y2: 400,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 380,
    x2: 320,
    y2: 400,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 380,
    x2: 340,
    y2: 400,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 380,
    x2: 360,
    y2: 400,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 380,
    x2: 380,
    y2: 400,
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 380,
    x2: 400,
    y2: 400,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 380,
    x2: 440,
    y2: 400,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 380,
    x2: 460,
    y2: 400,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 380,
    x2: 480,
    y2: 400,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 380,
    x2: 500,
    y2: 400,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 380,
    x2: 520,
    y2: 400,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 380,
    x2: 540,
    y2: 400,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 380,
    x2: 540,
    y2: 400,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 380,
    x2: 580,
    y2: 400,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 380,
    x2: 580,
    y2: 400,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 380,
    x2: 620,
    y2: 400,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 380,
    x2: 620,
    y2: 400,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 380,
    x2: 660,
    y2: 400,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 380,
    x2: 660,
    y2: 400,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 380,
    x2: 700,
    y2: 400,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 380,
    x2: 720,
    y2: 400,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 380,
    x2: 740,
    y2: 400,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 380,
    x2: 740,
    y2: 400,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 380,
    x2: 760,
    y2: 400,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 380,
    x2: 800,
    y2: 400,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 380,
    x2: 800,
    y2: 400,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 380,
    x2: 840,
    y2: 400,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 380,
    x2: 840,
    y2: 400,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 380,
    x2: 860,
    y2: 400,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 380,
    x2: 880,
    y2: 400,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 380,
    x2: 920,
    y2: 400,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 380,
    x2: 920,
    y2: 400,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 380,
    x2: 960,
    y2: 400,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 380,
    x2: 960,
    y2: 400,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 380,
    x2: 1000,
    y2: 400,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 380,
    x2: 1000,
    y2: 400,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 380,
    x2: 1040,
    y2: 400,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 380,
    x2: 1040,
    y2: 400,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 380,
    x2: 1080,
    y2: 400,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 380,
    x2: 1100,
    y2: 400,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 380,
    x2: 1120,
    y2: 400,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 380,
    x2: 1140,
    y2: 400,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 380,
    x2: 1160,
    y2: 400,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 380,
    x2: 1180,
    y2: 400,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 380,
    x2: 1180,
    y2: 400,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 380,
    x2: 1200,
    y2: 400,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 380,
    x2: 1240,
    y2: 400,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 380,
    x2: 1260,
    y2: 400,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 380,
    x2: 1280,
    y2: 400,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 380,
    x2: 1300,
    y2: 400,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 380,
    x2: 1320,
    y2: 400,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 380,
    x2: 1320,
    y2: 400,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 380,
    x2: 1360,
    y2: 400,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 380,
    x2: 1380,
    y2: 400,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 380,
    x2: 1400,
    y2: 400,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 380,
    x2: 1420,
    y2: 400,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 380,
    x2: 1440,
    y2: 400,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 400,
    x2: 0,
    y2: 420,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 400,
    x2: 40,
    y2: 420,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 400,
    x2: 40,
    y2: 420,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 400,
    x2: 80,
    y2: 420,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 400,
    x2: 100,
    y2: 420,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 400,
    x2: 100,
    y2: 420,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 400,
    x2: 120,
    y2: 420,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 400,
    x2: 140,
    y2: 420,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 400,
    x2: 160,
    y2: 420,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 400,
    x2: 180,
    y2: 420,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 400,
    x2: 220,
    y2: 420,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 400,
    x2: 240,
    y2: 420,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 400,
    x2: 260,
    y2: 420,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 400,
    x2: 280,
    y2: 420,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 400,
    x2: 280,
    y2: 420,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 400,
    x2: 300,
    y2: 420,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 400,
    x2: 320,
    y2: 420,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 400,
    x2: 360,
    y2: 420,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 400,
    x2: 360,
    y2: 420,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 400,
    x2: 400,
    y2: 420,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 400,
    x2: 400,
    y2: 420,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 400,
    x2: 420,
    y2: 420,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 400,
    x2: 440,
    y2: 420,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 400,
    x2: 460,
    y2: 420,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 400,
    x2: 480,
    y2: 420,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 400,
    x2: 520,
    y2: 420,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 400,
    x2: 540,
    y2: 420,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 400,
    x2: 560,
    y2: 420,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 400,
    x2: 560,
    y2: 420,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 400,
    x2: 580,
    y2: 420,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 400,
    x2: 600,
    y2: 420,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 400,
    x2: 620,
    y2: 420,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 400,
    x2: 660,
    y2: 420,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 400,
    x2: 680,
    y2: 420,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 400,
    x2: 680,
    y2: 420,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 400,
    x2: 700,
    y2: 420,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 400,
    x2: 740,
    y2: 420,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 400,
    x2: 740,
    y2: 420,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 400,
    x2: 780,
    y2: 420,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 400,
    x2: 780,
    y2: 420,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 400,
    x2: 800,
    y2: 420,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 400,
    x2: 820,
    y2: 420,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 400,
    x2: 860,
    y2: 420,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 400,
    x2: 880,
    y2: 420,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 400,
    x2: 900,
    y2: 420,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 400,
    x2: 900,
    y2: 420,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 400,
    x2: 940,
    y2: 420,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 400,
    x2: 960,
    y2: 420,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 400,
    x2: 980,
    y2: 420,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 400,
    x2: 1000,
    y2: 420,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 400,
    x2: 1020,
    y2: 420,
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 400,
    x2: 1040,
    y2: 420,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 400,
    x2: 1040,
    y2: 420,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 400,
    x2: 1060,
    y2: 420,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 400,
    x2: 1100,
    y2: 420,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 400,
    x2: 1100,
    y2: 420,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 400,
    x2: 1120,
    y2: 420,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 400,
    x2: 1160,
    y2: 420,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 400,
    x2: 1160,
    y2: 420,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 400,
    x2: 1180,
    y2: 420,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 400,
    x2: 1220,
    y2: 420,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 400,
    x2: 1220,
    y2: 420,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 400,
    x2: 1260,
    y2: 420,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 400,
    x2: 1280,
    y2: 420,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 400,
    x2: 1300,
    y2: 420,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 400,
    x2: 1320,
    y2: 420,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 400,
    x2: 1320,
    y2: 420,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 400,
    x2: 1360,
    y2: 420,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 400,
    x2: 1360,
    y2: 420,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 400,
    x2: 1380,
    y2: 420,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 400,
    x2: 1400,
    y2: 420,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 400,
    x2: 1420,
    y2: 420,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 420,
    x2: 20,
    y2: 440,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 420,
    x2: 40,
    y2: 440,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 420,
    x2: 60,
    y2: 440,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 420,
    x2: 60,
    y2: 440,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 420,
    x2: 80,
    y2: 440,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 420,
    x2: 100,
    y2: 440,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 420,
    x2: 120,
    y2: 440,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 420,
    x2: 140,
    y2: 440,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 420,
    x2: 180,
    y2: 440,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 420,
    x2: 200,
    y2: 440,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 420,
    x2: 220,
    y2: 440,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 420,
    x2: 240,
    y2: 440,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 420,
    x2: 260,
    y2: 440,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 420,
    x2: 280,
    y2: 440,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 420,
    x2: 300,
    y2: 440,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 420,
    x2: 300,
    y2: 440,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 420,
    x2: 320,
    y2: 440,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 420,
    x2: 360,
    y2: 440,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 420,
    x2: 380,
    y2: 440,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 420,
    x2: 400,
    y2: 440,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 420,
    x2: 420,
    y2: 440,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 420,
    x2: 420,
    y2: 440,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 420,
    x2: 440,
    y2: 440,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 420,
    x2: 480,
    y2: 440,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 420,
    x2: 500,
    y2: 440,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 420,
    x2: 520,
    y2: 440,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 420,
    x2: 520,
    y2: 440,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 420,
    x2: 560,
    y2: 440,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 420,
    x2: 580,
    y2: 440,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 420,
    x2: 580,
    y2: 440,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 420,
    x2: 620,
    y2: 440,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 420,
    x2: 620,
    y2: 440,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 420,
    x2: 660,
    y2: 440,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 420,
    x2: 680,
    y2: 440,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 420,
    x2: 700,
    y2: 440,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 420,
    x2: 720,
    y2: 440,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 420,
    x2: 740,
    y2: 440,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 420,
    x2: 760,
    y2: 440,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 420,
    x2: 780,
    y2: 440,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 420,
    x2: 780,
    y2: 440,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 420,
    x2: 800,
    y2: 440,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 420,
    x2: 840,
    y2: 440,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 420,
    x2: 840,
    y2: 440,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 420,
    x2: 860,
    y2: 440,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 420,
    x2: 880,
    y2: 440,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 420,
    x2: 900,
    y2: 440,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 420,
    x2: 940,
    y2: 440,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 420,
    x2: 940,
    y2: 440,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 420,
    x2: 980,
    y2: 440,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 420,
    x2: 980,
    y2: 440,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 420,
    x2: 1020,
    y2: 440,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 420,
    x2: 1040,
    y2: 440,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 420,
    x2: 1040,
    y2: 440,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 420,
    x2: 1060,
    y2: 440,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 420,
    x2: 1080,
    y2: 440,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 420,
    x2: 1120,
    y2: 440,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 420,
    x2: 1140,
    y2: 440,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 420,
    x2: 1160,
    y2: 440,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 420,
    x2: 1180,
    y2: 440,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 420,
    x2: 1180,
    y2: 440,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 420,
    x2: 1200,
    y2: 440,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 420,
    x2: 1220,
    y2: 440,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 420,
    x2: 1240,
    y2: 440,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 420,
    x2: 1260,
    y2: 440,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 420,
    x2: 1300,
    y2: 440,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 420,
    x2: 1300,
    y2: 440,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 420,
    x2: 1340,
    y2: 440,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 420,
    x2: 1340,
    y2: 440,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 420,
    x2: 1380,
    y2: 440,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 420,
    x2: 1380,
    y2: 440,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 420,
    x2: 1420,
    y2: 440,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 420,
    x2: 1420,
    y2: 440,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 440,
    x2: 20,
    y2: 460,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 440,
    x2: 40,
    y2: 460,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 440,
    x2: 60,
    y2: 460,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 440,
    x2: 60,
    y2: 460,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 440,
    x2: 100,
    y2: 460,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 440,
    x2: 100,
    y2: 460,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 440,
    x2: 140,
    y2: 460,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 440,
    x2: 160,
    y2: 460,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 440,
    x2: 160,
    y2: 460,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 440,
    x2: 200,
    y2: 460,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 440,
    x2: 200,
    y2: 460,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 440,
    x2: 220,
    y2: 460,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 440,
    x2: 240,
    y2: 460,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 440,
    x2: 260,
    y2: 460,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 440,
    x2: 300,
    y2: 460,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 440,
    x2: 320,
    y2: 460,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 440,
    x2: 340,
    y2: 460,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 440,
    x2: 340,
    y2: 460,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 440,
    x2: 380,
    y2: 460,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 440,
    x2: 380,
    y2: 460,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 440,
    x2: 400,
    y2: 460,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 440,
    x2: 420,
    y2: 460,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 440,
    x2: 440,
    y2: 460,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 440,
    x2: 460,
    y2: 460,
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 440,
    x2: 480,
    y2: 460,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 440,
    x2: 520,
    y2: 460,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 440,
    x2: 540,
    y2: 460,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 440,
    x2: 560,
    y2: 460,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 440,
    x2: 560,
    y2: 460,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 440,
    x2: 600,
    y2: 460,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 440,
    x2: 620,
    y2: 460,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 440,
    x2: 620,
    y2: 460,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 440,
    x2: 660,
    y2: 460,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 440,
    x2: 660,
    y2: 460,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 440,
    x2: 680,
    y2: 460,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 440,
    x2: 720,
    y2: 460,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 440,
    x2: 740,
    y2: 460,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 440,
    x2: 740,
    y2: 460,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 440,
    x2: 760,
    y2: 460,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 440,
    x2: 780,
    y2: 460,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 440,
    x2: 820,
    y2: 460,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 440,
    x2: 840,
    y2: 460,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 440,
    x2: 860,
    y2: 460,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 440,
    x2: 860,
    y2: 460,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 440,
    x2: 900,
    y2: 460,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 440,
    x2: 900,
    y2: 460,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 440,
    x2: 940,
    y2: 460,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 440,
    x2: 940,
    y2: 460,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 440,
    x2: 960,
    y2: 460,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 440,
    x2: 1000,
    y2: 460,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 440,
    x2: 1000,
    y2: 460,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 440,
    x2: 1040,
    y2: 460,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 440,
    x2: 1040,
    y2: 460,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 440,
    x2: 1060,
    y2: 460,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 440,
    x2: 1080,
    y2: 460,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 440,
    x2: 1120,
    y2: 460,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 440,
    x2: 1140,
    y2: 460,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 440,
    x2: 1160,
    y2: 460,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 440,
    x2: 1180,
    y2: 460,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 440,
    x2: 1200,
    y2: 460,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 440,
    x2: 1200,
    y2: 460,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 440,
    x2: 1240,
    y2: 460,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 440,
    x2: 1240,
    y2: 460,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 440,
    x2: 1260,
    y2: 460,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 440,
    x2: 1280,
    y2: 460,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 440,
    x2: 1300,
    y2: 460,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 440,
    x2: 1340,
    y2: 460,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 440,
    x2: 1360,
    y2: 460,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 440,
    x2: 1380,
    y2: 460,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 440,
    x2: 1400,
    y2: 460,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 440,
    x2: 1420,
    y2: 460,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 440,
    x2: 1420,
    y2: 460,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 460,
    x2: 0,
    y2: 480,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 460,
    x2: 40,
    y2: 480,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 460,
    x2: 60,
    y2: 480,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 460,
    x2: 80,
    y2: 480,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 460,
    x2: 80,
    y2: 480,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 460,
    x2: 100,
    y2: 480,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 460,
    x2: 120,
    y2: 480,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 460,
    x2: 160,
    y2: 480,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 460,
    x2: 180,
    y2: 480,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 460,
    x2: 200,
    y2: 480,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 460,
    x2: 220,
    y2: 480,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 460,
    x2: 220,
    y2: 480,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 460,
    x2: 260,
    y2: 480,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 460,
    x2: 260,
    y2: 480,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 460,
    x2: 300,
    y2: 480,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 460,
    x2: 300,
    y2: 480,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 460,
    x2: 320,
    y2: 480,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 460,
    x2: 360,
    y2: 480,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 460,
    x2: 360,
    y2: 480,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 460,
    x2: 380,
    y2: 480,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 460,
    x2: 400,
    y2: 480,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 460,
    x2: 420,
    y2: 480,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 460,
    x2: 460,
    y2: 480,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 460,
    x2: 480,
    y2: 480,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 460,
    x2: 480,
    y2: 480,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 460,
    x2: 520,
    y2: 480,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 460,
    x2: 540,
    y2: 480,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 460,
    x2: 560,
    y2: 480,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 460,
    x2: 580,
    y2: 480,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 460,
    x2: 600,
    y2: 480,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 460,
    x2: 600,
    y2: 480,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 460,
    x2: 620,
    y2: 480,
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 460,
    x2: 660,
    y2: 480,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 460,
    x2: 660,
    y2: 480,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 460,
    x2: 700,
    y2: 480,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 460,
    x2: 720,
    y2: 480,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 460,
    x2: 740,
    y2: 480,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 460,
    x2: 740,
    y2: 480,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 460,
    x2: 780,
    y2: 480,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 460,
    x2: 780,
    y2: 480,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 460,
    x2: 820,
    y2: 480,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 460,
    x2: 840,
    y2: 480,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 460,
    x2: 840,
    y2: 480,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 460,
    x2: 860,
    y2: 480,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 460,
    x2: 900,
    y2: 480,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 460,
    x2: 900,
    y2: 480,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 460,
    x2: 920,
    y2: 480,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 460,
    x2: 960,
    y2: 480,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 460,
    x2: 980,
    y2: 480,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 460,
    x2: 1000,
    y2: 480,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 460,
    x2: 1000,
    y2: 480,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 460,
    x2: 1040,
    y2: 480,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 460,
    x2: 1060,
    y2: 480,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 460,
    x2: 1060,
    y2: 480,
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 460,
    x2: 1080,
    y2: 480,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 460,
    x2: 1120,
    y2: 480,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 460,
    x2: 1140,
    y2: 480,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 460,
    x2: 1140,
    y2: 480,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 460,
    x2: 1160,
    y2: 480,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 460,
    x2: 1200,
    y2: 480,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 460,
    x2: 1200,
    y2: 480,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 460,
    x2: 1220,
    y2: 480,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 460,
    x2: 1240,
    y2: 480,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 460,
    x2: 1280,
    y2: 480,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 460,
    x2: 1300,
    y2: 480,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 460,
    x2: 1320,
    y2: 480,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 460,
    x2: 1320,
    y2: 480,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 460,
    x2: 1340,
    y2: 480,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 460,
    x2: 1380,
    y2: 480,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 460,
    x2: 1380,
    y2: 480,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 460,
    x2: 1420,
    y2: 480,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 460,
    x2: 1440,
    y2: 480,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 480,
    x2: 0,
    y2: 500,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 480,
    x2: 20,
    y2: 500,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 480,
    x2: 60,
    y2: 500,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 480,
    x2: 60,
    y2: 500,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 480,
    x2: 100,
    y2: 500,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 480,
    x2: 100,
    y2: 500,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 480,
    x2: 120,
    y2: 500,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 480,
    x2: 160,
    y2: 500,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 480,
    x2: 160,
    y2: 500,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 480,
    x2: 180,
    y2: 500,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 480,
    x2: 200,
    y2: 500,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 480,
    x2: 220,
    y2: 500,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 480,
    x2: 240,
    y2: 500,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 480,
    x2: 280,
    y2: 500,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 480,
    x2: 300,
    y2: 500,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 480,
    x2: 300,
    y2: 500,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 480,
    x2: 320,
    y2: 500,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 480,
    x2: 360,
    y2: 500,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 480,
    x2: 360,
    y2: 500,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 480,
    x2: 400,
    y2: 500,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 480,
    x2: 420,
    y2: 500,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 480,
    x2: 440,
    y2: 500,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 480,
    x2: 440,
    y2: 500,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 480,
    x2: 480,
    y2: 500,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 480,
    x2: 500,
    y2: 500,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 480,
    x2: 500,
    y2: 500,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 480,
    x2: 520,
    y2: 500,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 480,
    x2: 560,
    y2: 500,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 480,
    x2: 560,
    y2: 500,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 480,
    x2: 580,
    y2: 500,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 480,
    x2: 620,
    y2: 500,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 480,
    x2: 620,
    y2: 500,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 480,
    x2: 660,
    y2: 500,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 480,
    x2: 680,
    y2: 500,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 480,
    x2: 680,
    y2: 500,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 480,
    x2: 720,
    y2: 500,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 480,
    x2: 740,
    y2: 500,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 480,
    x2: 740,
    y2: 500,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 480,
    x2: 780,
    y2: 500,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 480,
    x2: 800,
    y2: 500,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 480,
    x2: 820,
    y2: 500,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 480,
    x2: 840,
    y2: 500,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 480,
    x2: 840,
    y2: 500,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 480,
    x2: 880,
    y2: 500,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 480,
    x2: 880,
    y2: 500,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 480,
    x2: 900,
    y2: 500,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 480,
    x2: 920,
    y2: 500,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 480,
    x2: 940,
    y2: 500,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 480,
    x2: 980,
    y2: 500,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 480,
    x2: 1000,
    y2: 500,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 480,
    x2: 1000,
    y2: 500,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 480,
    x2: 1020,
    y2: 500,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 480,
    x2: 1060,
    y2: 500,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 480,
    x2: 1060,
    y2: 500,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 480,
    x2: 1080,
    y2: 500,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 480,
    x2: 1120,
    y2: 500,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 480,
    x2: 1140,
    y2: 500,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 480,
    x2: 1140,
    y2: 500,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 480,
    x2: 1160,
    y2: 500,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 480,
    x2: 1180,
    y2: 500,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 480,
    x2: 1220,
    y2: 500,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 480,
    x2: 1220,
    y2: 500,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 480,
    x2: 1240,
    y2: 500,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 480,
    x2: 1260,
    y2: 500,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 480,
    x2: 1300,
    y2: 500,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 480,
    x2: 1300,
    y2: 500,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 480,
    x2: 1320,
    y2: 500,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 480,
    x2: 1340,
    y2: 500,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 480,
    x2: 1380,
    y2: 500,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 480,
    x2: 1400,
    y2: 500,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 480,
    x2: 1420,
    y2: 500,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 480,
    x2: 1440,
    y2: 500,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 500,
    x2: 0,
    y2: 520,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 500,
    x2: 20,
    y2: 520,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 500,
    x2: 40,
    y2: 520,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 500,
    x2: 80,
    y2: 520,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 500,
    x2: 80,
    y2: 520,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 500,
    x2: 100,
    y2: 520,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 500,
    x2: 140,
    y2: 520,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 500,
    x2: 160,
    y2: 520,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 500,
    x2: 160,
    y2: 520,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 500,
    x2: 200,
    y2: 520,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 500,
    x2: 200,
    y2: 520,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 500,
    x2: 220,
    y2: 520,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 500,
    x2: 260,
    y2: 520,
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 500,
    x2: 280,
    y2: 520,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 500,
    x2: 280,
    y2: 520,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 500,
    x2: 320,
    y2: 520,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 500,
    x2: 340,
    y2: 520,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 500,
    x2: 340,
    y2: 520,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 500,
    x2: 380,
    y2: 520,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 500,
    x2: 400,
    y2: 520,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 500,
    x2: 400,
    y2: 520,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 500,
    x2: 440,
    y2: 520,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 500,
    x2: 440,
    y2: 520,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 500,
    x2: 460,
    y2: 520,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 500,
    x2: 480,
    y2: 520,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 500,
    x2: 500,
    y2: 520,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 500,
    x2: 520,
    y2: 520,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 500,
    x2: 540,
    y2: 520,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 500,
    x2: 580,
    y2: 520,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 500,
    x2: 600,
    y2: 520,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 500,
    x2: 620,
    y2: 520,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 500,
    x2: 620,
    y2: 520,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 500,
    x2: 660,
    y2: 520,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 500,
    x2: 680,
    y2: 520,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 500,
    x2: 700,
    y2: 520,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 500,
    x2: 720,
    y2: 520,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 500,
    x2: 720,
    y2: 520,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 500,
    x2: 740,
    y2: 520,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 500,
    x2: 760,
    y2: 520,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 500,
    x2: 780,
    y2: 520,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 500,
    x2: 820,
    y2: 520,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 500,
    x2: 820,
    y2: 520,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 500,
    x2: 860,
    y2: 520,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 500,
    x2: 860,
    y2: 520,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 500,
    x2: 900,
    y2: 520,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 500,
    x2: 920,
    y2: 520,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 500,
    x2: 940,
    y2: 520,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 500,
    x2: 940,
    y2: 520,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 500,
    x2: 960,
    y2: 520,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 500,
    x2: 1000,
    y2: 520,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 500,
    x2: 1020,
    y2: 520,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 500,
    x2: 1040,
    y2: 520,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 500,
    x2: 1040,
    y2: 520,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 500,
    x2: 1060,
    y2: 520,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 500,
    x2: 1080,
    y2: 520,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 500,
    x2: 1100,
    y2: 520,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 500,
    x2: 1140,
    y2: 520,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 500,
    x2: 1140,
    y2: 520,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 500,
    x2: 1180,
    y2: 520,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 500,
    x2: 1180,
    y2: 520,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 500,
    x2: 1220,
    y2: 520,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 500,
    x2: 1240,
    y2: 520,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 500,
    x2: 1260,
    y2: 520,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 500,
    x2: 1260,
    y2: 520,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 500,
    x2: 1300,
    y2: 520,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 500,
    x2: 1320,
    y2: 520,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 500,
    x2: 1340,
    y2: 520,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 500,
    x2: 1360,
    y2: 520,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 500,
    x2: 1380,
    y2: 520,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 500,
    x2: 1400,
    y2: 520,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 500,
    x2: 1400,
    y2: 520,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 500,
    x2: 1440,
    y2: 520,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 520,
    x2: 0,
    y2: 540,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 520,
    x2: 40,
    y2: 540,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 520,
    x2: 40,
    y2: 540,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 520,
    x2: 80,
    y2: 540,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 520,
    x2: 100,
    y2: 540,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 520,
    x2: 100,
    y2: 540,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 520,
    x2: 140,
    y2: 540,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 520,
    x2: 140,
    y2: 540,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 520,
    x2: 180,
    y2: 540,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 520,
    x2: 200,
    y2: 540,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 520,
    x2: 200,
    y2: 540,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 520,
    x2: 220,
    y2: 540,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 520,
    x2: 240,
    y2: 540,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 520,
    x2: 260,
    y2: 540,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 520,
    x2: 280,
    y2: 540,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 520,
    x2: 320,
    y2: 540,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 520,
    x2: 320,
    y2: 540,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 520,
    x2: 340,
    y2: 540,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 520,
    x2: 380,
    y2: 540,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 520,
    x2: 400,
    y2: 540,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 520,
    x2: 400,
    y2: 540,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 520,
    x2: 440,
    y2: 540,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 520,
    x2: 440,
    y2: 540,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 520,
    x2: 460,
    y2: 540,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 520,
    x2: 500,
    y2: 540,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 520,
    x2: 500,
    y2: 540,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 520,
    x2: 540,
    y2: 540,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 520,
    x2: 560,
    y2: 540,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 520,
    x2: 580,
    y2: 540,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 520,
    x2: 600,
    y2: 540,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 520,
    x2: 620,
    y2: 540,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 520,
    x2: 620,
    y2: 540,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 520,
    x2: 660,
    y2: 540,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 520,
    x2: 660,
    y2: 540,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 520,
    x2: 700,
    y2: 540,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 520,
    x2: 700,
    y2: 540,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 520,
    x2: 720,
    y2: 540,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 520,
    x2: 760,
    y2: 540,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 520,
    x2: 780,
    y2: 540,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 520,
    x2: 800,
    y2: 540,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 520,
    x2: 820,
    y2: 540,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 520,
    x2: 840,
    y2: 540,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 520,
    x2: 840,
    y2: 540,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 520,
    x2: 860,
    y2: 540,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 520,
    x2: 900,
    y2: 540,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 520,
    x2: 920,
    y2: 540,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 520,
    x2: 920,
    y2: 540,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 520,
    x2: 940,
    y2: 540,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 520,
    x2: 980,
    y2: 540,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 520,
    x2: 1000,
    y2: 540,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 520,
    x2: 1000,
    y2: 540,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 520,
    x2: 1020,
    y2: 540,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 520,
    x2: 1060,
    y2: 540,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 520,
    x2: 1060,
    y2: 540,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 520,
    x2: 1100,
    y2: 540,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 520,
    x2: 1100,
    y2: 540,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 520,
    x2: 1140,
    y2: 540,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 520,
    x2: 1140,
    y2: 540,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 520,
    x2: 1180,
    y2: 540,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 520,
    x2: 1200,
    y2: 540,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 520,
    x2: 1200,
    y2: 540,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 520,
    x2: 1240,
    y2: 540,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 520,
    x2: 1260,
    y2: 540,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 520,
    x2: 1280,
    y2: 540,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 520,
    x2: 1280,
    y2: 540,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 520,
    x2: 1320,
    y2: 540,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 520,
    x2: 1320,
    y2: 540,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 520,
    x2: 1360,
    y2: 540,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 520,
    x2: 1360,
    y2: 540,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 520,
    x2: 1380,
    y2: 540,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 520,
    x2: 1420,
    y2: 540,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 520,
    x2: 1420,
    y2: 540,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 540,
    x2: 0,
    y2: 560,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 540,
    x2: 20,
    y2: 560,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 540,
    x2: 60,
    y2: 560,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 540,
    x2: 60,
    y2: 560,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 540,
    x2: 100,
    y2: 560,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 540,
    x2: 100,
    y2: 560,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 540,
    x2: 140,
    y2: 560,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 540,
    x2: 140,
    y2: 560,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 540,
    x2: 180,
    y2: 560,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 540,
    x2: 180,
    y2: 560,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 540,
    x2: 200,
    y2: 560,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 540,
    x2: 220,
    y2: 560,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 540,
    x2: 260,
    y2: 560,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 540,
    x2: 260,
    y2: 560,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 540,
    x2: 300,
    y2: 560,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 540,
    x2: 300,
    y2: 560,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 540,
    x2: 320,
    y2: 560,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 540,
    x2: 360,
    y2: 560,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 540,
    x2: 380,
    y2: 560,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 540,
    x2: 400,
    y2: 560,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 540,
    x2: 420,
    y2: 560,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 540,
    x2: 440,
    y2: 560,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 540,
    x2: 440,
    y2: 560,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 540,
    x2: 480,
    y2: 560,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 540,
    x2: 500,
    y2: 560,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 540,
    x2: 520,
    y2: 560,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 540,
    x2: 540,
    y2: 560,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 540,
    x2: 540,
    y2: 560,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 540,
    x2: 560,
    y2: 560,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 540,
    x2: 580,
    y2: 560,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 540,
    x2: 620,
    y2: 560,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 540,
    x2: 640,
    y2: 560,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 540,
    x2: 660,
    y2: 560,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 540,
    x2: 680,
    y2: 560,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 540,
    x2: 680,
    y2: 560,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 540,
    x2: 700,
    y2: 560,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 540,
    x2: 740,
    y2: 560,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 540,
    x2: 740,
    y2: 560,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 540,
    x2: 780,
    y2: 560,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 540,
    x2: 780,
    y2: 560,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 540,
    x2: 800,
    y2: 560,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 540,
    x2: 820,
    y2: 560,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 540,
    x2: 860,
    y2: 560,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 540,
    x2: 880,
    y2: 560,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 540,
    x2: 900,
    y2: 560,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 540,
    x2: 900,
    y2: 560,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 540,
    x2: 940,
    y2: 560,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 540,
    x2: 940,
    y2: 560,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 540,
    x2: 960,
    y2: 560,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 540,
    x2: 980,
    y2: 560,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 540,
    x2: 1000,
    y2: 560,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 540,
    x2: 1020,
    y2: 560,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 540,
    x2: 1040,
    y2: 560,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 540,
    x2: 1060,
    y2: 560,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 540,
    x2: 1080,
    y2: 560,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 540,
    x2: 1100,
    y2: 560,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 540,
    x2: 1140,
    y2: 560,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 540,
    x2: 1160,
    y2: 560,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 540,
    x2: 1180,
    y2: 560,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 540,
    x2: 1200,
    y2: 560,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 540,
    x2: 1200,
    y2: 560,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 540,
    x2: 1240,
    y2: 560,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 540,
    x2: 1260,
    y2: 560,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 540,
    x2: 1280,
    y2: 560,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 540,
    x2: 1280,
    y2: 560,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 540,
    x2: 1320,
    y2: 560,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 540,
    x2: 1340,
    y2: 560,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 540,
    x2: 1360,
    y2: 560,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 540,
    x2: 1360,
    y2: 560,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 540,
    x2: 1400,
    y2: 560,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 540,
    x2: 1400,
    y2: 560,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 540,
    x2: 1440,
    y2: 560,
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 560,
    x2: 20,
    y2: 580,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 560,
    x2: 40,
    y2: 580,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 560,
    x2: 60,
    y2: 580,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 560,
    x2: 60,
    y2: 580,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 560,
    x2: 100,
    y2: 580,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 560,
    x2: 100,
    y2: 580,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 560,
    x2: 120,
    y2: 580,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 560,
    x2: 160,
    y2: 580,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 560,
    x2: 160,
    y2: 580,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 560,
    x2: 180,
    y2: 580,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 560,
    x2: 200,
    y2: 580,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 560,
    x2: 240,
    y2: 580,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 560,
    x2: 240,
    y2: 580,
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 560,
    x2: 280,
    y2: 580,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 560,
    x2: 300,
    y2: 580,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 560,
    x2: 300,
    y2: 580,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 560,
    x2: 340,
    y2: 580,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 560,
    x2: 360,
    y2: 580,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 560,
    x2: 380,
    y2: 580,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 560,
    x2: 400,
    y2: 580,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 560,
    x2: 420,
    y2: 580,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 560,
    x2: 440,
    y2: 580,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 560,
    x2: 460,
    y2: 580,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 560,
    x2: 460,
    y2: 580,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 560,
    x2: 480,
    y2: 580,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 560,
    x2: 520,
    y2: 580,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 560,
    x2: 540,
    y2: 580,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 560,
    x2: 540,
    y2: 580,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 560,
    x2: 560,
    y2: 580,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 560,
    x2: 600,
    y2: 580,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 560,
    x2: 620,
    y2: 580,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 560,
    x2: 620,
    y2: 580,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 560,
    x2: 640,
    y2: 580,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 560,
    x2: 660,
    y2: 580,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 560,
    x2: 680,
    y2: 580,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 560,
    x2: 720,
    y2: 580,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 560,
    x2: 720,
    y2: 580,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 560,
    x2: 740,
    y2: 580,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 560,
    x2: 760,
    y2: 580,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 560,
    x2: 800,
    y2: 580,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 560,
    x2: 820,
    y2: 580,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 560,
    x2: 840,
    y2: 580,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 560,
    x2: 840,
    y2: 580,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 560,
    x2: 880,
    y2: 580,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 560,
    x2: 880,
    y2: 580,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 560,
    x2: 920,
    y2: 580,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 560,
    x2: 940,
    y2: 580,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 560,
    x2: 960,
    y2: 580,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 560,
    x2: 960,
    y2: 580,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 560,
    x2: 1000,
    y2: 580,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 560,
    x2: 1000,
    y2: 580,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 560,
    x2: 1040,
    y2: 580,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 560,
    x2: 1040,
    y2: 580,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 560,
    x2: 1080,
    y2: 580,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 560,
    x2: 1100,
    y2: 580,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 560,
    x2: 1100,
    y2: 580,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 560,
    x2: 1140,
    y2: 580,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 560,
    x2: 1140,
    y2: 580,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 560,
    x2: 1160,
    y2: 580,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 560,
    x2: 1200,
    y2: 580,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 560,
    x2: 1200,
    y2: 580,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 560,
    x2: 1220,
    y2: 580,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 560,
    x2: 1260,
    y2: 580,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 560,
    x2: 1280,
    y2: 580,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 560,
    x2: 1300,
    y2: 580,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 560,
    x2: 1320,
    y2: 580,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 560,
    x2: 1340,
    y2: 580,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 560,
    x2: 1360,
    y2: 580,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 560,
    x2: 1380,
    y2: 580,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 560,
    x2: 1380,
    y2: 580,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 560,
    x2: 1420,
    y2: 580,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 560,
    x2: 1440,
    y2: 580,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 580,
    x2: 20,
    y2: 600,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 580,
    x2: 20,
    y2: 600,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 580,
    x2: 40,
    y2: 600,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 580,
    x2: 80,
    y2: 600,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 580,
    x2: 80,
    y2: 600,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 580,
    x2: 120,
    y2: 600,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 580,
    x2: 120,
    y2: 600,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 580,
    x2: 160,
    y2: 600,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 580,
    x2: 180,
    y2: 600,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 580,
    x2: 180,
    y2: 600,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 580,
    x2: 200,
    y2: 600,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 580,
    x2: 240,
    y2: 600,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 580,
    x2: 240,
    y2: 600,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 580,
    x2: 280,
    y2: 600,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 580,
    x2: 280,
    y2: 600,
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 580,
    x2: 300,
    y2: 600,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 580,
    x2: 320,
    y2: 600,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 580,
    x2: 360,
    y2: 600,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 580,
    x2: 360,
    y2: 600,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 580,
    x2: 380,
    y2: 600,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 580,
    x2: 400,
    y2: 600,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 580,
    x2: 420,
    y2: 600,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 580,
    x2: 440,
    y2: 600,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 580,
    x2: 460,
    y2: 600,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 580,
    x2: 480,
    y2: 600,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 580,
    x2: 520,
    y2: 600,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 580,
    x2: 540,
    y2: 600,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 580,
    x2: 560,
    y2: 600,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 580,
    x2: 560,
    y2: 600,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 580,
    x2: 600,
    y2: 600,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 580,
    x2: 600,
    y2: 600,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 580,
    x2: 640,
    y2: 600,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 580,
    x2: 640,
    y2: 600,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 580,
    x2: 680,
    y2: 600,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 580,
    x2: 700,
    y2: 600,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 580,
    x2: 700,
    y2: 600,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 580,
    x2: 720,
    y2: 600,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 580,
    x2: 740,
    y2: 600,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 580,
    x2: 760,
    y2: 600,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 580,
    x2: 800,
    y2: 600,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 580,
    x2: 800,
    y2: 600,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 580,
    x2: 840,
    y2: 600,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 580,
    x2: 840,
    y2: 600,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 580,
    x2: 860,
    y2: 600,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 580,
    x2: 900,
    y2: 600,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 580,
    x2: 900,
    y2: 600,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 580,
    x2: 940,
    y2: 600,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 580,
    x2: 940,
    y2: 600,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 580,
    x2: 960,
    y2: 600,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 580,
    x2: 980,
    y2: 600,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 580,
    x2: 1000,
    y2: 600,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 580,
    x2: 1040,
    y2: 600,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 580,
    x2: 1060,
    y2: 600,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 580,
    x2: 1080,
    y2: 600,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 580,
    x2: 1080,
    y2: 600,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 580,
    x2: 1120,
    y2: 600,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 580,
    x2: 1120,
    y2: 600,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 580,
    x2: 1140,
    y2: 600,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 580,
    x2: 1180,
    y2: 600,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 580,
    x2: 1200,
    y2: 600,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 580,
    x2: 1220,
    y2: 600,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 580,
    x2: 1220,
    y2: 600,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 580,
    x2: 1240,
    y2: 600,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 580,
    x2: 1260,
    y2: 600,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 580,
    x2: 1280,
    y2: 600,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 580,
    x2: 1300,
    y2: 600,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 580,
    x2: 1340,
    y2: 600,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 580,
    x2: 1360,
    y2: 600,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 580,
    x2: 1360,
    y2: 600,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 580,
    x2: 1400,
    y2: 600,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 580,
    x2: 1400,
    y2: 600,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 580,
    x2: 1440,
    y2: 600,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 600,
    x2: 0,
    y2: 620,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 600,
    x2: 20,
    y2: 620,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 600,
    x2: 40,
    y2: 620,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 600,
    x2: 60,
    y2: 620,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 600,
    x2: 100,
    y2: 620,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 600,
    x2: 100,
    y2: 620,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 600,
    x2: 120,
    y2: 620,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 600,
    x2: 140,
    y2: 620,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 600,
    x2: 160,
    y2: 620,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 600,
    x2: 200,
    y2: 620,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 600,
    x2: 200,
    y2: 620,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 600,
    x2: 240,
    y2: 620,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 600,
    x2: 240,
    y2: 620,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 600,
    x2: 280,
    y2: 620,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 600,
    x2: 280,
    y2: 620,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 600,
    x2: 320,
    y2: 620,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 600,
    x2: 320,
    y2: 620,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 600,
    x2: 360,
    y2: 620,
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 600,
    x2: 360,
    y2: 620,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 600,
    x2: 380,
    y2: 620,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 600,
    x2: 400,
    y2: 620,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 600,
    x2: 440,
    y2: 620,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 600,
    x2: 460,
    y2: 620,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 600,
    x2: 460,
    y2: 620,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 600,
    x2: 500,
    y2: 620,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 600,
    x2: 520,
    y2: 620,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 600,
    x2: 520,
    y2: 620,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 600,
    x2: 540,
    y2: 620,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 600,
    x2: 560,
    y2: 620,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 600,
    x2: 580,
    y2: 620,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 600,
    x2: 600,
    y2: 620,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 600,
    x2: 620,
    y2: 620,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 600,
    x2: 660,
    y2: 620,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 600,
    x2: 660,
    y2: 620,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 600,
    x2: 700,
    y2: 620,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 600,
    x2: 700,
    y2: 620,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 600,
    x2: 740,
    y2: 620,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 600,
    x2: 760,
    y2: 620,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 600,
    x2: 780,
    y2: 620,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 600,
    x2: 780,
    y2: 620,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 600,
    x2: 800,
    y2: 620,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 600,
    x2: 820,
    y2: 620,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 600,
    x2: 840,
    y2: 620,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 600,
    x2: 880,
    y2: 620,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 600,
    x2: 880,
    y2: 620,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 600,
    x2: 920,
    y2: 620,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 600,
    x2: 920,
    y2: 620,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 600,
    x2: 940,
    y2: 620,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 600,
    x2: 960,
    y2: 620,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 600,
    x2: 980,
    y2: 620,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 600,
    x2: 1000,
    y2: 620,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 600,
    x2: 1020,
    y2: 620,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 600,
    x2: 1060,
    y2: 620,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 600,
    x2: 1080,
    y2: 620,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 600,
    x2: 1080,
    y2: 620,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 600,
    x2: 1120,
    y2: 620,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 600,
    x2: 1120,
    y2: 620,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 600,
    x2: 1140,
    y2: 620,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 600,
    x2: 1180,
    y2: 620,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 600,
    x2: 1200,
    y2: 620,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 600,
    x2: 1200,
    y2: 620,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 600,
    x2: 1220,
    y2: 620,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 600,
    x2: 1240,
    y2: 620,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 600,
    x2: 1260,
    y2: 620,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 600,
    x2: 1300,
    y2: 620,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 600,
    x2: 1320,
    y2: 620,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 600,
    x2: 1320,
    y2: 620,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 600,
    x2: 1340,
    y2: 620,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 600,
    x2: 1380,
    y2: 620,
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 600,
    x2: 1380,
    y2: 620,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 600,
    x2: 1400,
    y2: 620,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 600,
    x2: 1420,
    y2: 620,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 620,
    x2: 20,
    y2: 640,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 620,
    x2: 40,
    y2: 640,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 620,
    x2: 60,
    y2: 640,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 620,
    x2: 60,
    y2: 640,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 620,
    x2: 100,
    y2: 640,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 620,
    x2: 100,
    y2: 640,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 620,
    x2: 140,
    y2: 640,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 620,
    x2: 140,
    y2: 640,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 620,
    x2: 160,
    y2: 640,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 620,
    x2: 180,
    y2: 640,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 620,
    x2: 200,
    y2: 640,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 620,
    x2: 220,
    y2: 640,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 620,
    x2: 260,
    y2: 640,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 620,
    x2: 280,
    y2: 640,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 620,
    x2: 300,
    y2: 640,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 620,
    x2: 320,
    y2: 640,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 620,
    x2: 340,
    y2: 640,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 620,
    x2: 340,
    y2: 640,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 620,
    x2: 360,
    y2: 640,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 620,
    x2: 400,
    y2: 640,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 620,
    x2: 400,
    y2: 640,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 620,
    x2: 440,
    y2: 640,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 620,
    x2: 460,
    y2: 640,
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 620,
    x2: 460,
    y2: 640,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 620,
    x2: 480,
    y2: 640,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 620,
    x2: 520,
    y2: 640,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 620,
    x2: 520,
    y2: 640,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 620,
    x2: 540,
    y2: 640,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 620,
    x2: 580,
    y2: 640,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 620,
    x2: 580,
    y2: 640,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 620,
    x2: 620,
    y2: 640,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 620,
    x2: 640,
    y2: 640,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 620,
    x2: 660,
    y2: 640,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 620,
    x2: 660,
    y2: 640,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 620,
    x2: 680,
    y2: 640,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 620,
    x2: 720,
    y2: 640,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 620,
    x2: 720,
    y2: 640,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 620,
    x2: 760,
    y2: 640,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 620,
    x2: 760,
    y2: 640,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 620,
    x2: 780,
    y2: 640,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 620,
    x2: 800,
    y2: 640,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 620,
    x2: 820,
    y2: 640,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 620,
    x2: 860,
    y2: 640,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 620,
    x2: 860,
    y2: 640,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 620,
    x2: 880,
    y2: 640,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 620,
    x2: 900,
    y2: 640,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 620,
    x2: 920,
    y2: 640,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 620,
    x2: 960,
    y2: 640,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 620,
    x2: 960,
    y2: 640,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 620,
    x2: 1000,
    y2: 640,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 620,
    x2: 1020,
    y2: 640,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 620,
    x2: 1040,
    y2: 640,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 620,
    x2: 1060,
    y2: 640,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 620,
    x2: 1080,
    y2: 640,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 620,
    x2: 1080,
    y2: 640,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 620,
    x2: 1120,
    y2: 640,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 620,
    x2: 1120,
    y2: 640,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 620,
    x2: 1140,
    y2: 640,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 620,
    x2: 1160,
    y2: 640,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 620,
    x2: 1180,
    y2: 640,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 620,
    x2: 1220,
    y2: 640,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 620,
    x2: 1220,
    y2: 640,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 620,
    x2: 1240,
    y2: 640,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 620,
    x2: 1280,
    y2: 640,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 620,
    x2: 1300,
    y2: 640,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 620,
    x2: 1300,
    y2: 640,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 620,
    x2: 1320,
    y2: 640,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 620,
    x2: 1360,
    y2: 640,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 620,
    x2: 1360,
    y2: 640,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 620,
    x2: 1380,
    y2: 640,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 620,
    x2: 1400,
    y2: 640,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 620,
    x2: 1420,
    y2: 640,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 640,
    x2: 20,
    y2: 660,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 640,
    x2: 40,
    y2: 660,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 640,
    x2: 40,
    y2: 660,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 640,
    x2: 60,
    y2: 660,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 640,
    x2: 100,
    y2: 660,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 640,
    x2: 120,
    y2: 660,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 640,
    x2: 140,
    y2: 660,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 640,
    x2: 140,
    y2: 660,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 640,
    x2: 180,
    y2: 660,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 640,
    x2: 180,
    y2: 660,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 640,
    x2: 220,
    y2: 660,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 640,
    x2: 240,
    y2: 660,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 640,
    x2: 240,
    y2: 660,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 640,
    x2: 280,
    y2: 660,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 640,
    x2: 300,
    y2: 660,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 640,
    x2: 320,
    y2: 660,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 640,
    x2: 340,
    y2: 660,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 640,
    x2: 340,
    y2: 660,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 640,
    x2: 380,
    y2: 660,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 640,
    x2: 400,
    y2: 660,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 640,
    x2: 400,
    y2: 660,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 640,
    x2: 420,
    y2: 660,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 640,
    x2: 460,
    y2: 660,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 640,
    x2: 460,
    y2: 660,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 640,
    x2: 500,
    y2: 660,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 640,
    x2: 520,
    y2: 660,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 640,
    x2: 520,
    y2: 660,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 640,
    x2: 560,
    y2: 660,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 640,
    x2: 580,
    y2: 660,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 640,
    x2: 580,
    y2: 660,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 640,
    x2: 620,
    y2: 660,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 640,
    x2: 620,
    y2: 660,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 640,
    x2: 660,
    y2: 660,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 640,
    x2: 680,
    y2: 660,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 640,
    x2: 680,
    y2: 660,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 640,
    x2: 720,
    y2: 660,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 640,
    x2: 720,
    y2: 660,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 640,
    x2: 740,
    y2: 660,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 640,
    x2: 780,
    y2: 660,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 640,
    x2: 800,
    y2: 660,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 640,
    x2: 800,
    y2: 660,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 640,
    x2: 840,
    y2: 660,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 640,
    x2: 840,
    y2: 660,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 640,
    x2: 860,
    y2: 660,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 640,
    x2: 880,
    y2: 660,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 640,
    x2: 920,
    y2: 660,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 640,
    x2: 940,
    y2: 660,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 640,
    x2: 940,
    y2: 660,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 640,
    x2: 980,
    y2: 660,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 640,
    x2: 980,
    y2: 660,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 640,
    x2: 1000,
    y2: 660,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 640,
    x2: 1040,
    y2: 660,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 640,
    x2: 1040,
    y2: 660,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 640,
    x2: 1060,
    y2: 660,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 640,
    x2: 1080,
    y2: 660,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 640,
    x2: 1100,
    y2: 660,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 640,
    x2: 1120,
    y2: 660,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 640,
    x2: 1160,
    y2: 660,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 640,
    x2: 1180,
    y2: 660,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 640,
    x2: 1180,
    y2: 660,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 640,
    x2: 1220,
    y2: 660,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 640,
    x2: 1240,
    y2: 660,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 640,
    x2: 1240,
    y2: 660,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 640,
    x2: 1280,
    y2: 660,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 640,
    x2: 1300,
    y2: 660,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 640,
    x2: 1320,
    y2: 660,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 640,
    x2: 1320,
    y2: 660,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 640,
    x2: 1360,
    y2: 660,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 640,
    x2: 1360,
    y2: 660,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 640,
    x2: 1380,
    y2: 660,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 640,
    x2: 1400,
    y2: 660,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 640,
    x2: 1420,
    y2: 660,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 660,
    x2: 20,
    y2: 680,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 660,
    x2: 40,
    y2: 680,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 660,
    x2: 60,
    y2: 680,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 660,
    x2: 80,
    y2: 680,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 660,
    x2: 100,
    y2: 680,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 660,
    x2: 100,
    y2: 680,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 660,
    x2: 140,
    y2: 680,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 660,
    x2: 160,
    y2: 680,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 660,
    x2: 160,
    y2: 680,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 660,
    x2: 200,
    y2: 680,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 660,
    x2: 200,
    y2: 680,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 660,
    x2: 220,
    y2: 680,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 660,
    x2: 240,
    y2: 680,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 660,
    x2: 260,
    y2: 680,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 660,
    x2: 300,
    y2: 680,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 660,
    x2: 320,
    y2: 680,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 660,
    x2: 320,
    y2: 680,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 660,
    x2: 340,
    y2: 680,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 660,
    x2: 380,
    y2: 680,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 660,
    x2: 400,
    y2: 680,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 660,
    x2: 400,
    y2: 680,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 660,
    x2: 420,
    y2: 680,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 660,
    x2: 440,
    y2: 680,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 660,
    x2: 480,
    y2: 680,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 660,
    x2: 480,
    y2: 680,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 660,
    x2: 500,
    y2: 680,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 660,
    x2: 520,
    y2: 680,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 660,
    x2: 540,
    y2: 680,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 660,
    x2: 580,
    y2: 680,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 660,
    x2: 600,
    y2: 680,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 660,
    x2: 620,
    y2: 680,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 660,
    x2: 620,
    y2: 680,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 660,
    x2: 660,
    y2: 680,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 660,
    x2: 680,
    y2: 680,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 660,
    x2: 680,
    y2: 680,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 660,
    x2: 700,
    y2: 680,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 660,
    x2: 740,
    y2: 680,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 660,
    x2: 740,
    y2: 680,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 660,
    x2: 760,
    y2: 680,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 660,
    x2: 800,
    y2: 680,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 660,
    x2: 800,
    y2: 680,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 660,
    x2: 840,
    y2: 680,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 660,
    x2: 840,
    y2: 680,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 660,
    x2: 860,
    y2: 680,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 660,
    x2: 900,
    y2: 680,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 660,
    x2: 900,
    y2: 680,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 660,
    x2: 920,
    y2: 680,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 660,
    x2: 940,
    y2: 680,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 660,
    x2: 960,
    y2: 680,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 660,
    x2: 1000,
    y2: 680,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 660,
    x2: 1000,
    y2: 680,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 660,
    x2: 1040,
    y2: 680,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 660,
    x2: 1040,
    y2: 680,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 660,
    x2: 1080,
    y2: 680,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 660,
    x2: 1100,
    y2: 680,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 660,
    x2: 1120,
    y2: 680,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 660,
    x2: 1120,
    y2: 680,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 660,
    x2: 1140,
    y2: 680,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 660,
    x2: 1160,
    y2: 680,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 660,
    x2: 1200,
    y2: 680,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 660,
    x2: 1200,
    y2: 680,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 660,
    x2: 1240,
    y2: 680,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 660,
    x2: 1260,
    y2: 680,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 660,
    x2: 1280,
    y2: 680,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 660,
    x2: 1280,
    y2: 680,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 660,
    x2: 1320,
    y2: 680,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 660,
    x2: 1340,
    y2: 680,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 660,
    x2: 1340,
    y2: 680,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 660,
    x2: 1360,
    y2: 680,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 660,
    x2: 1380,
    y2: 680,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 660,
    x2: 1420,
    y2: 680,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 660,
    x2: 1420,
    y2: 680,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 680,
    x2: 20,
    y2: 700,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 680,
    x2: 40,
    y2: 700,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 680,
    x2: 60,
    y2: 700,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 680,
    x2: 80,
    y2: 700,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 680,
    x2: 80,
    y2: 700,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 680,
    x2: 100,
    y2: 700,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 680,
    x2: 140,
    y2: 700,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 680,
    x2: 140,
    y2: 700,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 680,
    x2: 160,
    y2: 700,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 680,
    x2: 180,
    y2: 700,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 680,
    x2: 220,
    y2: 700,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 680,
    x2: 240,
    y2: 700,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 680,
    x2: 260,
    y2: 700,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 680,
    x2: 260,
    y2: 700,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 680,
    x2: 280,
    y2: 700,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 680,
    x2: 300,
    y2: 700,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 680,
    x2: 340,
    y2: 700,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 680,
    x2: 360,
    y2: 700,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 680,
    x2: 380,
    y2: 700,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 680,
    x2: 400,
    y2: 700,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 680,
    x2: 400,
    y2: 700,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 680,
    x2: 420,
    y2: 700,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 680,
    x2: 440,
    y2: 700,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 680,
    x2: 480,
    y2: 700,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 680,
    x2: 480,
    y2: 700,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 680,
    x2: 520,
    y2: 700,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 680,
    x2: 540,
    y2: 700,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 680,
    x2: 560,
    y2: 700,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 680,
    x2: 560,
    y2: 700,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 680,
    x2: 600,
    y2: 700,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 680,
    x2: 600,
    y2: 700,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 680,
    x2: 620,
    y2: 700,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 680,
    x2: 660,
    y2: 700,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 680,
    x2: 680,
    y2: 700,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 680,
    x2: 680,
    y2: 700,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 680,
    x2: 720,
    y2: 700,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 680,
    x2: 720,
    y2: 700,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 680,
    x2: 760,
    y2: 700,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 680,
    x2: 780,
    y2: 700,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 680,
    x2: 800,
    y2: 700,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 680,
    x2: 800,
    y2: 700,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 680,
    x2: 840,
    y2: 700,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 680,
    x2: 840,
    y2: 700,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 680,
    x2: 880,
    y2: 700,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 680,
    x2: 900,
    y2: 700,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 680,
    x2: 900,
    y2: 700,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 680,
    x2: 920,
    y2: 700,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 680,
    x2: 940,
    y2: 700,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 680,
    x2: 960,
    y2: 700,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 680,
    x2: 1000,
    y2: 700,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 680,
    x2: 1000,
    y2: 700,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 680,
    x2: 1040,
    y2: 700,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 680,
    x2: 1060,
    y2: 700,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 680,
    x2: 1060,
    y2: 700,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 680,
    x2: 1080,
    y2: 700,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 680,
    x2: 1100,
    y2: 700,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 680,
    x2: 1140,
    y2: 700,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 680,
    x2: 1140,
    y2: 700,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 680,
    x2: 1160,
    y2: 700,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 680,
    x2: 1200,
    y2: 700,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 680,
    x2: 1220,
    y2: 700,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 680,
    x2: 1220,
    y2: 700,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 680,
    x2: 1260,
    y2: 700,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 680,
    x2: 1260,
    y2: 700,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 680,
    x2: 1300,
    y2: 700,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 680,
    x2: 1320,
    y2: 700,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 680,
    x2: 1320,
    y2: 700,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 680,
    x2: 1360,
    y2: 700,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 680,
    x2: 1360,
    y2: 700,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 680,
    x2: 1380,
    y2: 700,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 680,
    x2: 1400,
    y2: 700,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 680,
    x2: 1440,
    y2: 700,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 700,
    x2: 0,
    y2: 720,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 700,
    x2: 40,
    y2: 720,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 700,
    x2: 60,
    y2: 720,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 700,
    x2: 60,
    y2: 720,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 700,
    x2: 100,
    y2: 720,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 700,
    x2: 100,
    y2: 720,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 700,
    x2: 140,
    y2: 720,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 700,
    x2: 160,
    y2: 720,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 700,
    x2: 180,
    y2: 720,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 700,
    x2: 180,
    y2: 720,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 700,
    x2: 220,
    y2: 720,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 700,
    x2: 220,
    y2: 720,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 700,
    x2: 240,
    y2: 720,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 700,
    x2: 260,
    y2: 720,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 700,
    x2: 280,
    y2: 720,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 700,
    x2: 300,
    y2: 720,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 700,
    x2: 320,
    y2: 720,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 700,
    x2: 360,
    y2: 720,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 700,
    x2: 380,
    y2: 720,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 700,
    x2: 400,
    y2: 720,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 700,
    x2: 400,
    y2: 720,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 700,
    x2: 440,
    y2: 720,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 700,
    x2: 440,
    y2: 720,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 700,
    x2: 460,
    y2: 720,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 700,
    x2: 500,
    y2: 720,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 700,
    x2: 520,
    y2: 720,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 700,
    x2: 540,
    y2: 720,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 700,
    x2: 540,
    y2: 720,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 700,
    x2: 580,
    y2: 720,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 700,
    x2: 580,
    y2: 720,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 700,
    x2: 620,
    y2: 720,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 700,
    x2: 640,
    y2: 720,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 700,
    x2: 660,
    y2: 720,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 700,
    x2: 680,
    y2: 720,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 700,
    x2: 700,
    y2: 720,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 700,
    x2: 700,
    y2: 720,
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 700,
    x2: 740,
    y2: 720,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 700,
    x2: 760,
    y2: 720,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 700,
    x2: 780,
    y2: 720,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 700,
    x2: 800,
    y2: 720,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 700,
    x2: 800,
    y2: 720,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 700,
    x2: 820,
    y2: 720,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 700,
    x2: 840,
    y2: 720,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 700,
    x2: 860,
    y2: 720,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 700,
    x2: 880,
    y2: 720,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 700,
    x2: 920,
    y2: 720,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 700,
    x2: 940,
    y2: 720,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 700,
    x2: 940,
    y2: 720,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 700,
    x2: 960,
    y2: 720,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 700,
    x2: 980,
    y2: 720,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 700,
    x2: 1020,
    y2: 720,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 700,
    x2: 1020,
    y2: 720,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 700,
    x2: 1060,
    y2: 720,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 700,
    x2: 1080,
    y2: 720,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 700,
    x2: 1100,
    y2: 720,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 700,
    x2: 1100,
    y2: 720,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 700,
    x2: 1140,
    y2: 720,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 700,
    x2: 1160,
    y2: 720,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 700,
    x2: 1160,
    y2: 720,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 700,
    x2: 1180,
    y2: 720,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 700,
    x2: 1220,
    y2: 720,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 700,
    x2: 1220,
    y2: 720,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 700,
    x2: 1240,
    y2: 720,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 700,
    x2: 1280,
    y2: 720,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 700,
    x2: 1300,
    y2: 720,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 700,
    x2: 1300,
    y2: 720,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 700,
    x2: 1320,
    y2: 720,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 700,
    x2: 1360,
    y2: 720,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 700,
    x2: 1360,
    y2: 720,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 700,
    x2: 1400,
    y2: 720,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 700,
    x2: 1420,
    y2: 720,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 700,
    x2: 1440,
    y2: 720,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 720,
    x2: 20,
    y2: 740,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 720,
    x2: 20,
    y2: 740,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 720,
    x2: 60,
    y2: 740,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 720,
    x2: 80,
    y2: 740,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 720,
    x2: 80,
    y2: 740,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 720,
    x2: 100,
    y2: 740,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 720,
    x2: 140,
    y2: 740,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 720,
    x2: 160,
    y2: 740,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 720,
    x2: 180,
    y2: 740,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 720,
    x2: 200,
    y2: 740,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 720,
    x2: 220,
    y2: 740,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 720,
    x2: 220,
    y2: 740,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 720,
    x2: 260,
    y2: 740,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 720,
    x2: 280,
    y2: 740,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 720,
    x2: 280,
    y2: 740,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 720,
    x2: 300,
    y2: 740,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 720,
    x2: 320,
    y2: 740,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 720,
    x2: 360,
    y2: 740,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 720,
    x2: 360,
    y2: 740,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 720,
    x2: 400,
    y2: 740,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 720,
    x2: 420,
    y2: 740,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 720,
    x2: 420,
    y2: 740,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 720,
    x2: 460,
    y2: 740,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 720,
    x2: 480,
    y2: 740,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 720,
    x2: 500,
    y2: 740,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 720,
    x2: 520,
    y2: 740,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 720,
    x2: 520,
    y2: 740,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 720,
    x2: 560,
    y2: 740,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 720,
    x2: 560,
    y2: 740,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 720,
    x2: 600,
    y2: 740,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 720,
    x2: 600,
    y2: 740,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 720,
    x2: 620,
    y2: 740,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 720,
    x2: 660,
    y2: 740,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 720,
    x2: 660,
    y2: 740,
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 720,
    x2: 680,
    y2: 740,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 720,
    x2: 720,
    y2: 740,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 720,
    x2: 740,
    y2: 740,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 720,
    x2: 760,
    y2: 740,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 720,
    x2: 780,
    y2: 740,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 720,
    x2: 780,
    y2: 740,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 720,
    x2: 820,
    y2: 740,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 720,
    x2: 840,
    y2: 740,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 720,
    x2: 860,
    y2: 740,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 720,
    x2: 860,
    y2: 740,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 720,
    x2: 880,
    y2: 740,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 720,
    x2: 900,
    y2: 740,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 720,
    x2: 920,
    y2: 740,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 720,
    x2: 940,
    y2: 740,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 720,
    x2: 980,
    y2: 740,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 720,
    x2: 1000,
    y2: 740,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 720,
    x2: 1020,
    y2: 740,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 720,
    x2: 1040,
    y2: 740,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 720,
    x2: 1060,
    y2: 740,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 720,
    x2: 1060,
    y2: 740,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 720,
    x2: 1080,
    y2: 740,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 720,
    x2: 1120,
    y2: 740,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 720,
    x2: 1140,
    y2: 740,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 720,
    x2: 1140,
    y2: 740,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 720,
    x2: 1180,
    y2: 740,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 720,
    x2: 1200,
    y2: 740,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 720,
    x2: 1220,
    y2: 740,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 720,
    x2: 1220,
    y2: 740,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 720,
    x2: 1240,
    y2: 740,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 720,
    x2: 1260,
    y2: 740,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 720,
    x2: 1300,
    y2: 740,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 720,
    x2: 1320,
    y2: 740,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 720,
    x2: 1340,
    y2: 740,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 720,
    x2: 1340,
    y2: 740,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 720,
    x2: 1360,
    y2: 740,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 720,
    x2: 1400,
    y2: 740,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 720,
    x2: 1420,
    y2: 740,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 720,
    x2: 1420,
    y2: 740,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 740,
    x2: 0,
    y2: 760,
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 740,
    x2: 40,
    y2: 760,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 740,
    x2: 60,
    y2: 760,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 740,
    x2: 80,
    y2: 760,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 740,
    x2: 80,
    y2: 760,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 740,
    x2: 120,
    y2: 760,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 740,
    x2: 120,
    y2: 760,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 740,
    x2: 160,
    y2: 760,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 740,
    x2: 160,
    y2: 760,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 740,
    x2: 200,
    y2: 760,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 740,
    x2: 200,
    y2: 760,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 740,
    x2: 240,
    y2: 760,
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 740,
    x2: 260,
    y2: 760,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 740,
    x2: 280,
    y2: 760,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 740,
    x2: 280,
    y2: 760,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 740,
    x2: 320,
    y2: 760,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 740,
    x2: 340,
    y2: 760,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 740,
    x2: 360,
    y2: 760,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 740,
    x2: 380,
    y2: 760,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 740,
    x2: 400,
    y2: 760,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 740,
    x2: 400,
    y2: 760,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 740,
    x2: 420,
    y2: 760,
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 740,
    x2: 460,
    y2: 760,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 740,
    x2: 480,
    y2: 760,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 740,
    x2: 500,
    y2: 760,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 740,
    x2: 520,
    y2: 760,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 740,
    x2: 540,
    y2: 760,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 740,
    x2: 540,
    y2: 760,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 740,
    x2: 580,
    y2: 760,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 740,
    x2: 600,
    y2: 760,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 740,
    x2: 620,
    y2: 760,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 740,
    x2: 620,
    y2: 760,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 740,
    x2: 660,
    y2: 760,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 740,
    x2: 660,
    y2: 760,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 740,
    x2: 700,
    y2: 760,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 740,
    x2: 700,
    y2: 760,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 740,
    x2: 720,
    y2: 760,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 740,
    x2: 740,
    y2: 760,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 740,
    x2: 760,
    y2: 760,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 740,
    x2: 780,
    y2: 760,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 740,
    x2: 820,
    y2: 760,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 740,
    x2: 820,
    y2: 760,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 740,
    x2: 840,
    y2: 760,
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 740,
    x2: 860,
    y2: 760,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 740,
    x2: 900,
    y2: 760,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 740,
    x2: 920,
    y2: 760,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 740,
    x2: 920,
    y2: 760,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 740,
    x2: 940,
    y2: 760,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 740,
    x2: 980,
    y2: 760,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 740,
    x2: 1000,
    y2: 760,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 740,
    x2: 1000,
    y2: 760,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 740,
    x2: 1040,
    y2: 760,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 740,
    x2: 1040,
    y2: 760,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 740,
    x2: 1080,
    y2: 760,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 740,
    x2: 1080,
    y2: 760,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 740,
    x2: 1120,
    y2: 760,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 740,
    x2: 1140,
    y2: 760,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 740,
    x2: 1140,
    y2: 760,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 740,
    x2: 1180,
    y2: 760,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 740,
    x2: 1180,
    y2: 760,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 740,
    x2: 1220,
    y2: 760,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 740,
    x2: 1240,
    y2: 760,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 740,
    x2: 1260,
    y2: 760,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 740,
    x2: 1280,
    y2: 760,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 740,
    x2: 1300,
    y2: 760,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 740,
    x2: 1320,
    y2: 760,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 740,
    x2: 1340,
    y2: 760,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 740,
    x2: 1360,
    y2: 760,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 740,
    x2: 1380,
    y2: 760,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 740,
    x2: 1400,
    y2: 760,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 740,
    x2: 1420,
    y2: 760,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 740,
    x2: 1420,
    y2: 760,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 760,
    x2: 20,
    y2: 780,
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 760,
    x2: 40,
    y2: 780,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 760,
    x2: 60,
    y2: 780,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 760,
    x2: 60,
    y2: 780,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 760,
    x2: 100,
    y2: 780,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 760,
    x2: 100,
    y2: 780,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 760,
    x2: 120,
    y2: 780,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 760,
    x2: 160,
    y2: 780,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 760,
    x2: 180,
    y2: 780,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 760,
    x2: 200,
    y2: 780,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 760,
    x2: 220,
    y2: 780,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 760,
    x2: 220,
    y2: 780,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 760,
    x2: 240,
    y2: 780,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 760,
    x2: 260,
    y2: 780,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 760,
    x2: 300,
    y2: 780,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 760,
    x2: 320,
    y2: 780,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 760,
    x2: 340,
    y2: 780,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 760,
    x2: 340,
    y2: 780,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 760,
    x2: 360,
    y2: 780,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 760,
    x2: 380,
    y2: 780,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 760,
    x2: 400,
    y2: 780,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 760,
    x2: 420,
    y2: 780,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 760,
    x2: 440,
    y2: 780,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 760,
    x2: 460,
    y2: 780,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 760,
    x2: 500,
    y2: 780,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 760,
    x2: 520,
    y2: 780,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 760,
    x2: 520,
    y2: 780,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 760,
    x2: 560,
    y2: 780,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 760,
    x2: 560,
    y2: 780,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 760,
    x2: 580,
    y2: 780,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 760,
    x2: 620,
    y2: 780,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 760,
    x2: 640,
    y2: 780,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 760,
    x2: 640,
    y2: 780,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 760,
    x2: 680,
    y2: 780,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 760,
    x2: 680,
    y2: 780,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 760,
    x2: 700,
    y2: 780,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 760,
    x2: 720,
    y2: 780,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 760,
    x2: 740,
    y2: 780,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 760,
    x2: 780,
    y2: 780,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 760,
    x2: 800,
    y2: 780,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 760,
    x2: 800,
    y2: 780,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 760,
    x2: 820,
    y2: 780,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 760,
    x2: 840,
    y2: 780,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 760,
    x2: 880,
    y2: 780,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 760,
    x2: 880,
    y2: 780,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 760,
    x2: 920,
    y2: 780,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 760,
    x2: 920,
    y2: 780,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 760,
    x2: 940,
    y2: 780,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 760,
    x2: 960,
    y2: 780,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 760,
    x2: 980,
    y2: 780,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 760,
    x2: 1000,
    y2: 780,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 760,
    x2: 1040,
    y2: 780,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 760,
    x2: 1060,
    y2: 780,
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 760,
    x2: 1060,
    y2: 780,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 760,
    x2: 1100,
    y2: 780,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 760,
    x2: 1120,
    y2: 780,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 760,
    x2: 1120,
    y2: 780,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 760,
    x2: 1140,
    y2: 780,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 760,
    x2: 1180,
    y2: 780,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 760,
    x2: 1200,
    y2: 780,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 760,
    x2: 1200,
    y2: 780,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 760,
    x2: 1240,
    y2: 780,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 760,
    x2: 1240,
    y2: 780,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 760,
    x2: 1260,
    y2: 780,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 760,
    x2: 1300,
    y2: 780,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 760,
    x2: 1320,
    y2: 780,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 760,
    x2: 1320,
    y2: 780,
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 760,
    x2: 1340,
    y2: 780,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 760,
    x2: 1360,
    y2: 780,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 760,
    x2: 1400,
    y2: 780,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 760,
    x2: 1400,
    y2: 780,
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 760,
    x2: 1440,
    y2: 780,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 780,
    x2: 20,
    y2: 800,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 780,
    x2: 20,
    y2: 800,
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 780,
    x2: 60,
    y2: 800,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 780,
    x2: 60,
    y2: 800,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 780,
    x2: 100,
    y2: 800,
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 780,
    x2: 100,
    y2: 800,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 780,
    x2: 120,
    y2: 800,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 780,
    x2: 140,
    y2: 800,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 780,
    x2: 160,
    y2: 800,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 780,
    x2: 200,
    y2: 800,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 780,
    x2: 200,
    y2: 800,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 780,
    x2: 240,
    y2: 800,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 780,
    x2: 260,
    y2: 800,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 780,
    x2: 260,
    y2: 800,
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 780,
    x2: 280,
    y2: 800,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 780,
    x2: 300,
    y2: 800,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 780,
    x2: 320,
    y2: 800,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 780,
    x2: 340,
    y2: 800,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 780,
    x2: 380,
    y2: 800,
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 780,
    x2: 380,
    y2: 800,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 780,
    x2: 420,
    y2: 800,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 780,
    x2: 440,
    y2: 800,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 780,
    x2: 440,
    y2: 800,
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 780,
    x2: 480,
    y2: 800,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 780,
    x2: 480,
    y2: 800,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 780,
    x2: 500,
    y2: 800,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 780,
    x2: 520,
    y2: 800,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 780,
    x2: 560,
    y2: 800,
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 780,
    x2: 580,
    y2: 800,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 780,
    x2: 600,
    y2: 800,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 780,
    x2: 620,
    y2: 800,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 780,
    x2: 620,
    y2: 800,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 780,
    x2: 640,
    y2: 800,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 780,
    x2: 680,
    y2: 800,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 780,
    x2: 680,
    y2: 800,
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 780,
    x2: 720,
    y2: 800,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 780,
    x2: 720,
    y2: 800,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 780,
    x2: 740,
    y2: 800,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 780,
    x2: 780,
    y2: 800,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 780,
    x2: 800,
    y2: 800,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 780,
    x2: 820,
    y2: 800,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 780,
    x2: 820,
    y2: 800,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 780,
    x2: 840,
    y2: 800,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 780,
    x2: 860,
    y2: 800,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 780,
    x2: 900,
    y2: 800,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 780,
    x2: 920,
    y2: 800,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 780,
    x2: 920,
    y2: 800,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 780,
    x2: 960,
    y2: 800,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 780,
    x2: 980,
    y2: 800,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 780,
    x2: 980,
    y2: 800,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 780,
    x2: 1000,
    y2: 800,
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 780,
    x2: 1020,
    y2: 800,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 780,
    x2: 1040,
    y2: 800,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 780,
    x2: 1080,
    y2: 800,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 780,
    x2: 1100,
    y2: 800,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 780,
    x2: 1100,
    y2: 800,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 780,
    x2: 1140,
    y2: 800,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 780,
    x2: 1160,
    y2: 800,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 780,
    x2: 1160,
    y2: 800,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 780,
    x2: 1180,
    y2: 800,
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 780,
    x2: 1220,
    y2: 800,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 780,
    x2: 1220,
    y2: 800,
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 780,
    x2: 1240,
    y2: 800,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 780,
    x2: 1260,
    y2: 800,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 780,
    x2: 1280,
    y2: 800,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 780,
    x2: 1320,
    y2: 800,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 780,
    x2: 1320,
    y2: 800,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 780,
    x2: 1340,
    y2: 800,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 780,
    x2: 1380,
    y2: 800,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 780,
    x2: 1380,
    y2: 800,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 780,
    x2: 1420,
    y2: 800,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 780,
    x2: 1420,
    y2: 800,
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 800,
    x2: 20,
    y2: 820,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 800,
    x2: 20,
    y2: 820,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 800,
    x2: 60,
    y2: 820,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 800,
    x2: 80,
    y2: 820,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 800,
    x2: 80,
    y2: 820,
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 800,
    x2: 120,
    y2: 820,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 800,
    x2: 140,
    y2: 820,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 800,
    x2: 160,
    y2: 820,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 800,
    x2: 160,
    y2: 820,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 800,
    x2: 200,
    y2: 820,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 800,
    x2: 220,
    y2: 820,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 800,
    x2: 240,
    y2: 820,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 800,
    x2: 260,
    y2: 820,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 800,
    x2: 260,
    y2: 820,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 800,
    x2: 300,
    y2: 820,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 800,
    x2: 300,
    y2: 820,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 800,
    x2: 340,
    y2: 820,
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 800,
    x2: 340,
    y2: 820,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 800,
    x2: 360,
    y2: 820,
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 800,
    x2: 400,
    y2: 820,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 800,
    x2: 400,
    y2: 820,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 800,
    x2: 440,
    y2: 820,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 800,
    x2: 440,
    y2: 820,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 800,
    x2: 460,
    y2: 820,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 800,
    x2: 480,
    y2: 820,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 800,
    x2: 520,
    y2: 820,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 800,
    x2: 540,
    y2: 820,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 800,
    x2: 540,
    y2: 820,
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 800,
    x2: 580,
    y2: 820,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 800,
    x2: 600,
    y2: 820,
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 800,
    x2: 620,
    y2: 820,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 800,
    x2: 640,
    y2: 820,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 800,
    x2: 660,
    y2: 820,
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 800,
    x2: 660,
    y2: 820,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 800,
    x2: 700,
    y2: 820,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 800,
    x2: 700,
    y2: 820,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 800,
    x2: 720,
    y2: 820,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 800,
    x2: 740,
    y2: 820,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 800,
    x2: 760,
    y2: 820,
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 800,
    x2: 780,
    y2: 820,
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 800,
    x2: 820,
    y2: 820,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 800,
    x2: 840,
    y2: 820,
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 800,
    x2: 840,
    y2: 820,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 800,
    x2: 880,
    y2: 820,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 800,
    x2: 880,
    y2: 820,
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 800,
    x2: 900,
    y2: 820,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 800,
    x2: 920,
    y2: 820,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 800,
    x2: 940,
    y2: 820,
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 800,
    x2: 980,
    y2: 820,
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 800,
    x2: 980,
    y2: 820,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 800,
    x2: 1020,
    y2: 820,
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 800,
    x2: 1020,
    y2: 820,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 800,
    x2: 1060,
    y2: 820,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 800,
    x2: 1060,
    y2: 820,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 800,
    x2: 1100,
    y2: 820,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 800,
    x2: 1120,
    y2: 820,
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 800,
    x2: 1140,
    y2: 820,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 800,
    x2: 1140,
    y2: 820,
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 800,
    x2: 1180,
    y2: 820,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 800,
    x2: 1180,
    y2: 820,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 800,
    x2: 1200,
    y2: 820,
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 800,
    x2: 1240,
    y2: 820,
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 800,
    x2: 1260,
    y2: 820,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 800,
    x2: 1260,
    y2: 820,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 800,
    x2: 1300,
    y2: 820,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 800,
    x2: 1300,
    y2: 820,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 800,
    x2: 1340,
    y2: 820,
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 800,
    x2: 1340,
    y2: 820,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 800,
    x2: 1360,
    y2: 820,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 800,
    x2: 1400,
    y2: 820,
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 800,
    x2: 1400,
    y2: 820,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 800,
    x2: 1440,
    y2: 820,
    opacity: 0.76
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtten);
export default __webpack_public_path__ + "static/media/ttten.9f0a0879a699cd4415c258e3dce10416.svg";
export { ForwardRef as ReactComponent };